<template>
  <div class="procesos-container">
    <!-- Unified Container -->
    <div class="unified-container">
      <!-- Header Section -->
      <div class="header-section">
        <div class="title-section">
          <v-icon class="title-icon" color="white">mdi-application-cog</v-icon>
          <div class="title-text">
            <h1 class="main-title">PROCESOS COMPRAS</h1>
            <p class="subtitle">Gestión de procesos de compra</p>
          </div>
        </div>
      </div>

      <!-- Search Section -->
      <div class="search-section">
        <div class="search-card">
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Buscar Proceso"
            solo
            flat
            hide-details
            class="search-field"
          ></v-text-field>
        </div>
      </div>
      <!-- Van todos los dialog usa -->
      <!-- dialog Proveedor 1 -->
      <!-- Dialog Proveedor 1 -->
      <v-dialog
        v-model="dialog"
        max-width="1000px"
        persistent
        overlay-color="black"
        overlay-opacity="0.8"
      >
        <v-card>
          <v-card-title class="nav">
            <span class="headline" style="color: white"
              ><v-icon color="white">mdi-application-cog</v-icon>
              {{ formTitle }}</span
            >
          </v-card-title>
          <v-card-text>
            <v-container grid-list-md>
              <v-row class="d-flex" style="width: 950px">
                <!-- Formulario a la izquierda -->
                <v-col
                  cols="5"
                  style="
                    background: #f7f9fa;
                    border-radius: 18px;
                    box-shadow: 0 4px 24px #e0e0e055;
                    width: 450px;
                  "
                >
                  <div
                    class="font-weight-bold mb-6 text-center"
                    style="
                      font-size: 22px;
                      letter-spacing: 1px;
                      display: flex;
                      align-items: center;
                      justify-content: center;
                      gap: 10px;
                    "
                  >
                    <v-icon color="primary">mdi-domain</v-icon>
                    Datos del Proveedor
                  </div>
                  <v-text-field
                    label="NIT"
                    v-model="editedItem.infoProveedores.proveedor1.nit"
                    @blur="consultarProveedor('proveedor1')"
                    @input="validarNitInput('proveedor1')"
                    :rules="nitRules"
                    :error-messages="nitErrorMessages"
                    hint="Escribe entre 8 y 15 dígitos (se permiten guiones, puntos, espacios, @)"
                    persistent-hint
                    maxlength="15"
                    counter="15"
                  >
                    <template v-slot:append>
                      <v-progress-circular
                        v-if="isConsulting"
                        indeterminate
                        size="20"
                        color="primary"
                      ></v-progress-circular>
                      <v-icon
                        v-else-if="
                          editedItem.infoProveedores.proveedor1.nit &&
                          esNitValidoVisual(
                            editedItem.infoProveedores.proveedor1.nit,
                          )
                        "
                        color="success"
                        small
                      >
                        mdi-check-circle
                      </v-icon>
                    </template>
                  </v-text-field>

                  <!-- 🎯 MENSAJE DE CREACIÓN PARA PROVEEDOR 1 -->
                  <v-alert
                    v-if="showCreateMessage1"
                    color="grey lighten-4"
                    text-color="grey darken-2"
                    outlined
                    class="mt-2 mensaje-creacion"
                  >
                    <div class="d-flex align-center">
                      <v-icon class="mr-3" color="grey darken-1"
                        >mdi-information-outline</v-icon
                      >
                      <div class="flex-grow-1">
                        <div class="text-subtitle2 font-weight-medium mb-1">
                          Proveedor no registrado
                        </div>
                        <div class="text-caption text--secondary">
                          Este NIT no existe en la base de datos. ¿Desea crear
                          un nuevo proveedor?
                        </div>
                      </div>
                    </div>
                    <v-card-actions class="pa-0 mt-2">
                      <v-btn
                        color="primary"
                        small
                        depressed
                        @click="crearProveedorConfirmado('proveedor1')"
                        :loading="isCreating"
                        class="mr-2"
                      >
                        <v-icon
                          left
                          small
                          class="icono-crear-blanco"
                          style="color: white !important"
                          >mdi-plus</v-icon
                        >
                        Crear Proveedor
                      </v-btn>
                      <v-btn
                        color="grey"
                        small
                        outlined
                        @click="ocultarMensajeCreacion('proveedor1')"
                      >
                        Cancelar
                      </v-btn>
                    </v-card-actions>
                  </v-alert>
                  <v-text-field
                    label="Nombre Empresa"
                    v-model="
                      editedItem.infoProveedores.proveedor1.nombreEmpresa
                    "
                    class="mb-3"
                  ></v-text-field>
                  <v-text-field
                    label="Contacto"
                    v-model="editedItem.infoProveedores.proveedor1.contacto"
                    class="mb-3"
                  ></v-text-field>
                  <v-text-field
                    label="Teléfono"
                    v-model="editedItem.infoProveedores.proveedor1.telefono"
                    class="mb-3"
                  ></v-text-field>
                  <v-text-field
                    label="Dirección de Entrega"
                    v-model="
                      editedItem.infoProveedores.proveedor1.direccionEntrega
                    "
                    class="mb-3"
                  ></v-text-field>
                  <v-select
                    :items="areas"
                    item-text="nombreArea"
                    item-value="idArea"
                    label="Quién ejecuta el presupuesto"
                    v-model="selectedAreaId"
                    @change="setEjecutaPresupuestoNombre('proveedor1')"
                    class="mb-3"
                    outlined
                    dense
                  ></v-select>
                  <v-file-input
                    v-model="selectedFile"
                    label="Adjuntar archivo"
                    accept=".jpg,.jpeg,.png,.gif,.pdf,.doc,.docx"
                    class="mb-3"
                  ></v-file-input>
                </v-col>
                <!-- Información del proceso a la derecha -->
                <v-col
                  cols="7"
                  style="
                    background: #fafbfc;
                    width: 280px;
                    border: 1px solid #e0e0e0;
                    padding: 16px;
                  "
                >
                  <div
                    class="font-weight-bold mb-4 text-center"
                    style="
                      font-size: 20px;
                      letter-spacing: 1px;
                      display: flex;
                      align-items: center;
                      justify-content: center;
                      gap: 8px;
                    "
                  >
                    <v-icon color="primary">mdi-format-list-bulleted</v-icon>
                    Información del Proceso
                  </div>
                  <v-row
                    v-for="(item, index) in editedItem.infoProceso"
                    :key="index"
                    class="mb-4"
                    style="
                      border: 1px solid #e0e0e0;
                      min-width: 250px;
                      border-radius: 12px;
                      padding: 1rem;
                      background: #fff;
                      box-shadow: 0 2px 8px #e0e0e033;
                    "
                  >
                    <v-col cols="12">
                      <h4 class="mb-2">
                        <strong>Descripción:</strong> {{ item.concepto }}
                      </h4>
                      <div class="d-flex flex-wrap" style="gap: 18px">
                        <span
                          ><strong>Cantidad:</strong> {{ item.cantidad }}</span
                        >
                        <span
                          ><strong>Detalle técnico:</strong>
                          {{ item.expecificaciones }}</span
                        >
                        <span
                          ><strong>Argumento para la compra:</strong>
                          {{ item.observaciones }}</span
                        >
                        <span
                          ><strong>Presupuesto:</strong>
                          {{ item.presupuesto }}</span
                        >
                        <span
                          ><strong>Fecha requerida:</strong>
                          {{ item.fecha }}</span
                        >
                      </div>
                    </v-col>
                    <v-col cols="12" v-if="estadoDescripciones === true">
                      <v-row style="padding: 0 8px">
                        <v-col cols="6" v-if="item.cantidad == 0">
                          <v-text-field
                            label="Valor Unitario"
                            v-model="arregloDescripciones[index].valorUnitario"
                            @input="
                              formatearValorUnitario(
                                arregloDescripciones[index],
                                $event,
                                item.cantidad,
                              )
                            "
                            @blur="
                              cambioValorTotal(
                                arregloDescripciones[index],
                                item.cantidad,
                              )
                            "
                            type="text"
                            placeholder="0"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="6" v-if="item.cantidad == 0">
                          <v-text-field
                            label="Iva"
                            v-model="arregloDescripciones[index].iva"
                            type="number"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" v-else>
                          <v-text-field
                            label="Valor Unitario"
                            v-model="arregloDescripciones[index].valorUnitario"
                            @input="
                              formatearValorUnitario(
                                arregloDescripciones[index],
                                $event,
                                item.cantidad,
                              )
                            "
                            @blur="
                              cambioValorTotal(
                                arregloDescripciones[index],
                                item.cantidad,
                              )
                            "
                            type="text"
                            placeholder="0"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <!-- botones para cancelar y agregar y validacion de campos vacios -->
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="#f7e506" @click="close">Cancelar</v-btn>
            <v-btn
              color="#f7e506"
              :loading="isSaving"
              :disabled="
                !editedItem.infoProveedores.proveedor1.nombreEmpresa ||
                faltaValorUnitario(arregloDescripciones)
              "
              @click="handleSave"
            >
              Guardar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- Dialog Proveedor 2 -->
      <v-dialog
        v-model="dialog1"
        max-width="1000px"
        persistent
        overlay-color="black"
        overlay-opacity="0.8"
      >
        <v-card>
          <v-card-title class="nav">
            <span class="headline" style="color: white"
              ><v-icon color="white">mdi-application-cog</v-icon>
              {{ formTitle1 }}</span
            >
          </v-card-title>
          <v-card-text>
            <v-container grid-list-md>
              <v-row class="d-flex" style="width: 950px">
                <!-- Formulario a la izquierda -->
                <v-col
                  cols="5"
                  style="
                    background: #f7f9fa;
                    border-radius: 18px;
                    box-shadow: 0 4px 24px #e0e0e055;
                    width: 450px;
                  "
                >
                  <div
                    class="font-weight-bold mb-6 text-center"
                    style="
                      font-size: 22px;
                      letter-spacing: 1px;
                      display: flex;
                      align-items: center;
                      justify-content: center;
                      gap: 10px;
                    "
                  >
                    <v-icon color="primary">mdi-domain</v-icon>
                    Datos del Proveedor
                  </div>
                  <v-text-field
                    label="NIT"
                    v-model="editedItem1.infoProveedores.proveedor2.nit"
                    @blur="consultarProveedor('proveedor2')"
                    @input="validarNitInput('proveedor2')"
                    :rules="nitRules"
                    :error-messages="nitErrorMessages"
                    hint="Escribe entre 8 y 15 dígitos (se permiten guiones, puntos, espacios, @)"
                    persistent-hint
                    maxlength="15"
                    counter="15"
                  >
                    <template v-slot:append>
                      <v-progress-circular
                        v-if="isConsulting"
                        indeterminate
                        size="20"
                        color="primary"
                      ></v-progress-circular>
                      <v-icon
                        v-else-if="
                          editedItem1.infoProveedores.proveedor2.nit &&
                          esNitValidoVisual(
                            editedItem1.infoProveedores.proveedor2.nit,
                          )
                        "
                        color="success"
                        small
                      >
                        mdi-check-circle
                      </v-icon>
                    </template>
                  </v-text-field>

                  <!--  MENSAJE DE CREACIÓN PARA PROVEEDOR 2 -->
                  <v-alert
                    v-if="showCreateMessage2"
                    color="grey lighten-4"
                    text-color="grey darken-2"
                    outlined
                    class="mt-2 mensaje-creacion"
                  >
                    <div class="d-flex align-center">
                      <v-icon class="mr-3" color="grey darken-1"
                        >mdi-information-outline</v-icon
                      >
                      <div class="flex-grow-1">
                        <div class="text-subtitle2 font-weight-medium mb-1">
                          Proveedor no registrado
                        </div>
                        <div class="text-caption text--secondary">
                          Este NIT no existe en la base de datos. ¿Desea crear
                          un nuevo proveedor?
                        </div>
                      </div>
                    </div>
                    <v-card-actions class="pa-0 mt-2">
                      <v-btn
                        color="primary"
                        small
                        depressed
                        @click="crearProveedorConfirmado('proveedor2')"
                        :loading="isCreating"
                        class="mr-2"
                      >
                        <v-icon
                          left
                          small
                          class="icono-crear-blanco"
                          style="color: white !important"
                          >mdi-plus</v-icon
                        >
                        Crear Proveedor
                      </v-btn>
                      <v-btn
                        color="grey"
                        small
                        outlined
                        @click="ocultarMensajeCreacion('proveedor2')"
                      >
                        Cancelar
                      </v-btn>
                    </v-card-actions>
                  </v-alert>
                  <v-text-field
                    label="Nombre Empresa"
                    v-model="
                      editedItem1.infoProveedores.proveedor2.nombreEmpresa
                    "
                    class="mb-3"
                  ></v-text-field>
                  <v-text-field
                    label="Contacto"
                    v-model="editedItem1.infoProveedores.proveedor2.contacto"
                    class="mb-3"
                  ></v-text-field>
                  <v-text-field
                    label="Teléfono"
                    v-model="editedItem1.infoProveedores.proveedor2.telefono"
                    class="mb-3"
                  ></v-text-field>
                  <v-text-field
                    label="Dirección de Entrega"
                    v-model="
                      editedItem1.infoProveedores.proveedor2.direccionEntrega
                    "
                    class="mb-3"
                  ></v-text-field>
                  <v-select
                    :items="areas"
                    item-text="nombreArea"
                    item-value="idArea"
                    label="Quién ejecuta el presupuesto"
                    v-model="selectedAreaId2"
                    @change="setEjecutaPresupuestoNombre('proveedor2')"
                    class="mb-3"
                    outlined
                    dense
                  ></v-select>
                  <v-file-input
                    v-model="selectedFile2"
                    label="Adjuntar archivo"
                    accept=".jpg,.jpeg,.png,.gif,.pdf,.doc,.docx"
                    class="mb-3"
                  ></v-file-input>
                </v-col>
                <!-- Información del proceso a la derecha -->
                <v-col
                  cols="7"
                  style="
                    background: #fafbfc;
                    width: 280px;
                    border: 1px solid #e0e0e0;
                    padding: 16px;
                  "
                >
                  <div
                    class="font-weight-bold mb-4 text-center"
                    style="
                      font-size: 20px;
                      letter-spacing: 1px;
                      display: flex;
                      align-items: center;
                      justify-content: center;
                      gap: 8px;
                    "
                  >
                    <v-icon color="primary">mdi-format-list-bulleted</v-icon>
                    Información del Proceso
                  </div>
                  <v-row
                    v-for="(item, index) in editedItem1.infoProceso"
                    :key="index"
                    class="mb-4"
                    style="
                      border: 1px solid #e0e0e0;
                      min-width: 250px;
                      border-radius: 12px;
                      padding: 1rem;
                      background: #fff;
                      box-shadow: 0 2px 8px #e0e0e033;
                    "
                  >
                    <v-col cols="12">
                      <h4 class="mb-2">
                        <strong>Descripción:</strong> {{ item.concepto }}
                      </h4>
                      <div class="d-flex flex-wrap" style="gap: 18px">
                        <span
                          ><strong>Cantidad:</strong> {{ item.cantidad }}</span
                        >
                        <span
                          ><strong>Detalle técnico:</strong>
                          {{ item.expecificaciones }}</span
                        >
                        <span
                          ><strong>Argumento para la compra:</strong>
                          {{ item.observaciones }}</span
                        >
                        <span
                          ><strong>Presupuesto:</strong>
                          {{ item.presupuesto }}</span
                        >
                        <span
                          ><strong>Fecha requerida:</strong>
                          {{ item.fecha }}</span
                        >
                      </div>
                    </v-col>
                    <v-col cols="12" v-if="estadoDescripciones1 === true">
                      <v-row style="padding: 0 8px">
                        <v-col cols="6" v-if="item.cantidad == 0">
                          <v-text-field
                            label="Valor Unitario"
                            v-model="arregloDescripciones1[index].valorUnitario"
                            @input="
                              formatearValorUnitario(
                                arregloDescripciones1[index],
                                $event,
                                item.cantidad,
                              )
                            "
                            @blur="
                              cambioValorTotal1(
                                arregloDescripciones1[index],
                                item.cantidad,
                              )
                            "
                            type="text"
                            placeholder="0"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="6" v-if="item.cantidad == 0">
                          <v-text-field
                            label="Iva"
                            v-model="arregloDescripciones1[index].iva"
                            type="number"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" v-else>
                          <v-text-field
                            label="Valor Unitario"
                            v-model="arregloDescripciones1[index].valorUnitario"
                            @input="
                              formatearValorUnitario(
                                arregloDescripciones1[index],
                                $event,
                                item.cantidad,
                              )
                            "
                            @blur="
                              cambioValorTotal1(
                                arregloDescripciones1[index],
                                item.cantidad,
                              )
                            "
                            type="text"
                            placeholder="0"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                    </v-col>
                    <v-col cols="12" v-if="estadoDescripciones1 === false">
                      <v-row>
                        <v-col cols="4">
                          <v-text-field
                            label="Valor Unitario"
                            type="text"
                            placeholder="0"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="4">
                          <v-text-field
                            label="Valor Total"
                            type="number"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="4">
                          <v-text-field
                            label="Iva"
                            type="number"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <!-- botones para cancelar y agregar y validacion de campos vacios -->
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="#f7e506" @click="close1">Cancelar</v-btn>
            <v-btn
              color="#f7e506"
              :loading="isSaving"
              :disabled="!validarFormularioProveedor2()"
              @click="handleSave2()"
            >
              Guardar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- Dialog Proveedor 3 -->
      <v-dialog
        v-model="dialog2"
        max-width="1000px"
        persistent
        overlay-color="black"
        overlay-opacity="0.8"
      >
        <v-card>
          <v-card-title class="nav">
            <span class="headline" style="color: white"
              ><v-icon color="white">mdi-application-cog</v-icon>
              {{ formTitle2 }}</span
            >
          </v-card-title>
          <v-card-text>
            <v-container grid-list-md>
              <v-row class="d-flex" style="width: 950px">
                <!-- Formulario a la izquierda -->
                <v-col
                  cols="5"
                  style="
                    background: #f7f9fa;
                    border-radius: 18px;
                    box-shadow: 0 4px 24px #e0e0e055;
                    width: 450px;
                  "
                >
                  <div
                    class="font-weight-bold mb-6 text-center"
                    style="
                      font-size: 22px;
                      letter-spacing: 1px;
                      display: flex;
                      align-items: center;
                      justify-content: center;
                      gap: 10px;
                    "
                  >
                    <v-icon color="primary">mdi-domain</v-icon>
                    Datos del Proveedor
                  </div>
                  <v-text-field
                    label="NIT"
                    v-model="editedItem2.infoProveedores.proveedor3.nit"
                    @blur="consultarProveedor('proveedor3')"
                    @input="validarNitInput('proveedor3')"
                    :rules="nitRules"
                    :error-messages="nitErrorMessages"
                    hint="Escribe entre 8 y 15 dígitos (se permiten guiones, puntos, espacios, @)"
                    persistent-hint
                    maxlength="15"
                    counter="15"
                  >
                    <template v-slot:append>
                      <v-progress-circular
                        v-if="isConsulting"
                        indeterminate
                        size="20"
                        color="primary"
                      ></v-progress-circular>
                      <v-icon
                        v-else-if="
                          editedItem2.infoProveedores.proveedor3.nit &&
                          esNitValidoVisual(
                            editedItem2.infoProveedores.proveedor3.nit,
                          )
                        "
                        color="success"
                        small
                      >
                        mdi-check-circle
                      </v-icon>
                    </template>
                  </v-text-field>

                  <!--  MENSAJE DE CREACIÓN PARA PROVEEDOR 3 -->
                  <v-alert
                    v-if="showCreateMessage3"
                    color="grey lighten-4"
                    text-color="grey darken-2"
                    outlined
                    class="mt-2 mensaje-creacion"
                  >
                    <div class="d-flex align-center">
                      <v-icon class="mr-3" color="grey darken-1"
                        >mdi-information-outline</v-icon
                      >
                      <div class="flex-grow-1">
                        <div class="text-subtitle2 font-weight-medium mb-1">
                          Proveedor no registrado
                        </div>
                        <div class="text-caption text--secondary">
                          Este NIT no existe en la base de datos. ¿Desea crear
                          un nuevo proveedor?
                        </div>
                      </div>
                    </div>
                    <v-card-actions class="pa-0 mt-2">
                      <v-btn
                        color="primary"
                        small
                        depressed
                        @click="crearProveedorConfirmado('proveedor3')"
                        :loading="isCreating"
                        class="mr-2"
                      >
                        <v-icon
                          left
                          small
                          class="icono-crear-blanco"
                          style="color: white !important"
                          >mdi-plus</v-icon
                        >
                        Crear Proveedor
                      </v-btn>
                      <v-btn
                        color="grey"
                        small
                        outlined
                        @click="ocultarMensajeCreacion('proveedor3')"
                      >
                        Cancelar
                      </v-btn>
                    </v-card-actions>
                  </v-alert>
                  <v-text-field
                    label="Nombre Empresa"
                    v-model="
                      editedItem2.infoProveedores.proveedor3.nombreEmpresa
                    "
                    class="mb-3"
                  ></v-text-field>
                  <v-text-field
                    label="Contacto"
                    v-model="editedItem2.infoProveedores.proveedor3.contacto"
                    class="mb-3"
                  ></v-text-field>
                  <v-text-field
                    label="Teléfono"
                    v-model="editedItem2.infoProveedores.proveedor3.telefono"
                    class="mb-3"
                  ></v-text-field>
                  <v-text-field
                    label="Dirección de Entrega"
                    v-model="
                      editedItem2.infoProveedores.proveedor3.direccionEntrega
                    "
                    class="mb-3"
                  ></v-text-field>
                  <v-select
                    :items="areas"
                    item-text="nombreArea"
                    item-value="idArea"
                    label="Quién ejecuta el presupuesto"
                    v-model="selectedAreaId3"
                    @change="setEjecutaPresupuestoNombre('proveedor3')"
                    class="mb-3"
                    outlined
                    dense
                  ></v-select>
                  <v-file-input
                    v-model="selectedFile3"
                    label="Adjuntar archivo"
                    accept=".jpg,.jpeg,.png,.gif,.pdf,.doc,.docx"
                    class="mb-3"
                  ></v-file-input>
                </v-col>
                <!-- Información del proceso a la derecha -->
                <v-col
                  cols="7"
                  style="
                    background: #fafbfc;
                    width: 280px;
                    border: 1px solid #e0e0e0;
                    padding: 16px;
                  "
                >
                  <div
                    class="font-weight-bold mb-4 text-center"
                    style="
                      font-size: 20px;
                      letter-spacing: 1px;
                      display: flex;
                      align-items: center;
                      justify-content: center;
                      gap: 8px;
                    "
                  >
                    <v-icon color="primary">mdi-format-list-bulleted</v-icon>
                    Información del Proceso
                  </div>
                  <v-row
                    v-for="(item, index) in editedItem2.infoProceso"
                    :key="index"
                    class="mb-4"
                    style="
                      border: 1px solid #e0e0e0;
                      min-width: 250px;
                      border-radius: 12px;
                      padding: 1rem;
                      background: #fff;
                      box-shadow: 0 2px 8px #e0e0e033;
                    "
                  >
                    <v-col cols="12">
                      <h4 class="mb-2">
                        <strong>Descripción:</strong> {{ item.concepto }}
                      </h4>
                      <div class="d-flex flex-wrap" style="gap: 18px">
                        <span
                          ><strong>Cantidad:</strong> {{ item.cantidad }}</span
                        >
                        <span
                          ><strong>Detalle técnico:</strong>
                          {{ item.expecificaciones }}</span
                        >
                        <span
                          ><strong>Argumento para la compra:</strong>
                          {{ item.observaciones }}</span
                        >
                        <span
                          ><strong>Presupuesto:</strong>
                          {{ item.presupuesto }}</span
                        >
                        <span
                          ><strong>Fecha requerida:</strong>
                          {{ item.fecha }}</span
                        >
                      </div>
                    </v-col>
                    <v-col cols="12" v-if="estadoDescripciones2 === true">
                      <v-row style="padding: 0 8px">
                        <v-col cols="6" v-if="item.cantidad == 0">
                          <v-text-field
                            label="Valor Unitario"
                            v-model="arregloDescripciones2[index].valorUnitario"
                            @input="
                              formatearValorUnitario(
                                arregloDescripciones2[index],
                                $event,
                                item.cantidad,
                              )
                            "
                            @blur="
                              cambioValorTotal2(
                                arregloDescripciones2[index],
                                item.cantidad,
                              )
                            "
                            type="text"
                            placeholder="0"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="6" v-if="item.cantidad == 0">
                          <v-text-field
                            label="Iva"
                            v-model="arregloDescripciones2[index].iva"
                            type="number"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" v-else>
                          <v-text-field
                            label="Valor Unitario"
                            v-model="arregloDescripciones2[index].valorUnitario"
                            @input="
                              formatearValorUnitario(
                                arregloDescripciones2[index],
                                $event,
                                item.cantidad,
                              )
                            "
                            @blur="
                              cambioValorTotal2(
                                arregloDescripciones2[index],
                                item.cantidad,
                              )
                            "
                            type="text"
                            placeholder="0"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                    </v-col>
                    <v-col cols="12" v-if="estadoDescripciones2 === false">
                      <v-row>
                        <v-col cols="4">
                          <v-text-field
                            label="Valor Unitario"
                            type="text"
                            placeholder="0"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="4">
                          <v-text-field
                            label="Valor Total"
                            type="number"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="4">
                          <v-text-field
                            label="Iva"
                            type="number"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <!-- botones para cancelar y agregar y validacion de campos vacios -->
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="#f7e506" @click="close2">Cancelar</v-btn>
            <v-btn
              color="#f7e506"
              :loading="isSaving"
              :disabled="!validarFormularioProveedor3()"
              @click="handleSave3"
            >
              Guardar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- dialog observacion -->
      <v-dialog
        v-model="observacionDialog"
        max-width="500px"
        persistent
        overlay-color="black"
        overlay-opacity="0.8"
      >
        <v-card>
          <v-card-title class="nav">
            <span class="headline" style="color: black"
              ><v-icon color="black">mdi-application-cog</v-icon> Agregar
              observación</span
            >
          </v-card-title>
          <v-card-text>
            <v-container class="">
              <v-layout wrap>
                <v-flex xs12 sm12 md12>
                  <v-text-field
                    label="Observación"
                    v-model="nuevaObservacion"
                    class="mr-3"
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>

          <!-- botones para cancelar y agregregar y validacion de campos vacios -->
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="#f7e506" @click="cerrarObservacion">Cancelar</v-btn>
            <v-btn color="#f7e506" @click="enviarObservacion">Guardar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog
        v-model="dialogpdf"
        persistent:overlay="false"
        width="90%"
        overlay-color="black"
        overlay-opacity="0.8"
      >
        <v-card>
          <v-card-title class="nav" overlay-color="black" overlay-opacity="0.8">
            <span class="headline" style="color: white"
              ><v-icon color="white">mdi-clipboard-edit-outline</v-icon>
              Editar Proceso
            </span>
          </v-card-title>

          <!-- compras rechazadas -->
          <div style="width: 95%; margin: 3rem 0rem 0rem 2rem">
            <v-layout wrap>
              <v-flex
                xs9
                sm9
                md9
                style="border-top: 1px solid black; border-left: 1px solid"
              >
              </v-flex>
              <v-flex
                xs1
                sm1
                md1
                style="border: solid 1px black; border-right: 0px"
                class="displayCenter fondo"
              >
                <span><strong>Proveedor 1</strong></span>
              </v-flex>
              <v-flex
                xs1
                sm1
                md1
                style="border: solid 1px black; border-right: 0px"
                class="displayCenter fondo"
              >
                <span><strong>Proveedor 2</strong></span>
              </v-flex>
              <v-flex
                xs1
                sm1
                md1
                style="border: solid 1px black"
                class="displayCenter fondo"
              >
                <span><strong>Proveedor 3</strong></span>
              </v-flex>
            </v-layout>
            <v-layout wrap>
              <v-flex
                xs2
                sm2
                md2
                style="border: solid 1px black; border-right: 0px"
                class="displayCenter fondo"
              >
                <strong>DESCRIPCION</strong>
              </v-flex>
              <v-flex
                xs3
                sm3
                md3
                style="border: solid 1px black"
                class="displayCenter fondo"
              >
                <strong>DETALLE TÉCNICO</strong>
              </v-flex>
              <v-flex
                xs3
                sm3
                md3
                style="border: solid 1px black; border-right: 0px"
                class="displayCenter fondo"
              >
                <strong>ARGUMENTO PARA LA COMPRA</strong>
              </v-flex>
              <v-flex
                xs1
                sm1
                md1
                style="border: solid 1px black"
                class="displayCenter fondo"
              >
                <strong>CANT</strong>
              </v-flex>
              <v-layout wrap>
                <v-flex
                  xs4
                  sm4
                  md4
                  style="border: solid 1px black"
                  class="displayCenter fondo"
                >
                  <span style="font-size: 14px"
                    ><strong>VALOR UNITARIO</strong></span
                  >
                </v-flex>
                <v-flex
                  xs4
                  sm4
                  md4
                  style="border: solid 1px black"
                  class="displayCenter fondo"
                >
                  <span style="font-size: 14px"
                    ><strong>VALOR UNITARIO</strong></span
                  >
                </v-flex>
                <v-flex
                  xs4
                  sm4
                  md4
                  style="border: solid 1px black"
                  class="displayCenter fondo"
                >
                  <span style="font-size: 14px"
                    ><strong>VALOR UNITARIO</strong></span
                  >
                </v-flex>
              </v-layout>
            </v-layout>
            <v-layout
              wrap
              v-for="(item, index) in editedItemDenegados.infoProceso"
              :key="index"
              style="border: solid 1px black; border-top: 0px"
            >
              <v-flex
                xs2
                sm2
                md2
                style="border-right: solid 1px black"
                class="displayCenter"
              >
                {{ item.concepto }}
              </v-flex>
              <v-flex xs3 sm3 md3 style="border-right: solid 1px black">
                {{ item.expecificaciones }}
              </v-flex>
              <v-flex xs3 sm3 md3 style="border-right: solid 1px black">
                {{ item.observaciones }}
              </v-flex>
              <v-flex
                xs1
                sm1
                md1
                style="border-right: solid 1px black"
                class="displayCenter"
              >
                {{ item.cantidad }}
              </v-flex>
              <v-flex
                xs1
                sm1
                md1
                style="border-right: solid 1px black"
                class="displayEnd"
              >
                {{
                  formatValorUnitario(
                    editedItemDenegados.proveedor1.valores[index].valorUnitario,
                  )
                }}
              </v-flex>
              <v-flex
                xs1
                sm1
                md1
                style="border-right: solid 1px black"
                class="displayEnd"
              >
                {{
                  formatValorUnitario(
                    editedItemDenegados.proveedor2.valores[index].valorUnitario,
                  )
                }}
              </v-flex>
              <v-flex
                xs1
                sm1
                md1
                style="border-right: solid 1px black"
                class="displayEnd"
              >
                {{
                  formatValorUnitario(
                    editedItemDenegados.proveedor3.valores[index].valorUnitario,
                  )
                }}
              </v-flex>
            </v-layout>

            <v-layout wrap>
              <v-flex
                xs6
                sm6
                md6
                v-if="dialogpdf === true"
                style="border: solid 1px black; border-top: 0px"
                class="displayCenter fondo"
              >
                <label for=""><strong>NOMBRE EMPRESA</strong></label>
              </v-flex>
              <v-flex
                xs2
                sm2
                md2
                v-if="dialogpdf === true"
                style="
                  border: solid 1px black;
                  border-top: 0px;
                  border-left: 0px;
                "
                class="displayCenter"
              >
                <label for="">{{
                  editedItemDenegados.proveedor1.nombreEmpresa
                }}</label>
              </v-flex>
              <v-flex
                xs2
                sm2
                md2
                v-if="dialogpdf === true"
                style="
                  border: solid 1px black;
                  border-top: 0px;
                  border-left: 0px;
                "
                class="displayCenter"
              >
                <label for="">{{
                  editedItemDenegados.proveedor2.nombreEmpresa
                }}</label>
              </v-flex>
              <v-flex
                xs2
                sm2
                md2
                v-if="dialogpdf === true"
                style="
                  border: solid 1px black;
                  border-top: 0px;
                  border-left: 0px;
                "
                class="displayCenter"
              >
                <label for="">{{
                  editedItemDenegados.proveedor3.nombreEmpresa
                }}</label>
              </v-flex>
            </v-layout>
            <v-layout wrap>
              <v-flex
                xs6
                sm6
                md6
                v-if="dialogpdf === true"
                style="border: solid 1px black; border-top: 0px"
                class="displayCenter fondo"
              >
                <label for=""> <strong>ARGUMENTO PARA LA COMPRA</strong></label>
              </v-flex>
              <v-flex
                xs6
                sm6
                md6
                v-if="dialogpdf === true"
                style="
                  border: solid 1px black;
                  border-top: 0px;
                  border-left: 0px;
                "
                class="displayCenter"
              >
                <label for="">{{ editedItemDenegados.observacion }}</label>
              </v-flex>
            </v-layout>

            <v-layout row wrap class="mt-5">
              <v-flex xs3 sm3 md3>
                <v-text-field
                  disabled
                  label="Mayra Londoño"
                  class="mr-4"
                ></v-text-field>
                <label for="">ELABORADO POR</label>
              </v-flex>
              <v-layout
                wrap
                v-for="(item, index) in editedItemDenegados.aprobacion"
                :key="index"
              >
                <v-flex xs3 sm3 md3 v-if="item.rol === 'DIRECTOR AREA'">
                  <v-text-field :value="item.firma" disabled></v-text-field>
                  <label for="">APROBACION DIRECTOR DE ÁREA</label>
                </v-flex>
                <v-flex xs3 sm3 md3 v-if="item.rol === 'CONTROL INTERNO'">
                  <v-text-field disabled :value="item.firma"></v-text-field>
                  <label for="">REVISIÓN DIRECCION FINANCIERA</label>
                </v-flex>
                <v-flex xs3 sm3 md3 v-if="item.rol === 'GERENTE'">
                  <v-text-field disabled :value="item.firma"></v-text-field>
                  <label for="">APROBACIÓN DE LA GERENCIA</label>
                </v-flex>
              </v-layout>
            </v-layout>
          </div>

          <!-- botones para cancelar y agregregar y validacion de campos vacios -->
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn elevation="2" color="#f7e506" @click="close">Cerrar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- Tabs Section -->
      <div class="tabs-section">
        <div class="tabs-card">
          <v-tabs
            v-model="tab2"
            background-color="#3b82f6"
            centered
            dark
            grow
            icons-and-text
            class="modern-tabs"
          >
            <v-tabs-slider class="tabs-slider"></v-tabs-slider>

            <v-tab href="#tab-1" class="custom-tab">
              <span class="tab-text">PENDIENTES</span>
              <v-icon class="tab-icon">mdi-clipboard-alert</v-icon>
            </v-tab>

            <v-tab href="#tab-2" class="custom-tab">
              <span class="tab-text">DENEGADOS</span>
              <v-icon class="tab-icon">mdi-clipboard-remove</v-icon>
            </v-tab>

            <v-tab-item :value="'tab-1'" class="tab-content">
              <div class="table-section">
                <v-data-table
                  :headers="headers"
                  :items="procesos"
                  :search="search"
                  class="modern-table"
                  :items-per-page="10"
                  :footer-props="{
                    'items-per-page-options': [10, 20, 50],
                    'items-per-page-text': 'Filas por página:',
                  }"
                >
                  <template v-slot:[`item.proveedor1`]="{ item }">
                    <div v-if="item.proveedor1 == null">
                      <v-icon @click="dialogProveedor1(item)" color="green">
                        mdi-account-plus
                      </v-icon>
                    </div>
                    <div v-else>
                      <v-icon
                        @click="limpiarProveedor(item, 'proveedor1')"
                        color="red"
                      >
                        mdi-account-remove
                      </v-icon>
                    </div>
                  </template>

                  <template v-slot:[`item.proveedor2`]="{ item }">
                    <div v-if="item.proveedor1 == null">
                      <!-- vacío porque depende del proveedor1 -->
                    </div>
                    <div v-else-if="item.proveedor2 == null">
                      <v-icon @click="dialogProveedor2(item)" color="green">
                        mdi-account-plus
                      </v-icon>
                    </div>
                    <div v-else>
                      <v-icon
                        @click="limpiarProveedor(item, 'proveedor2')"
                        color="red"
                      >
                        mdi-account-remove
                      </v-icon>
                    </div>
                  </template>

                  <template v-slot:[`item.proveedor3`]="{ item }">
                    <div v-if="item.proveedor2 == null">
                      <!-- vacío porque depende del proveedor2 -->
                    </div>
                    <div v-else-if="item.proveedor3 == null">
                      <v-icon @click="dialogProveedor3(item)" color="green">
                        mdi-account-plus
                      </v-icon>
                    </div>
                    <div v-else>
                      <v-icon
                        @click="limpiarProveedor(item, 'proveedor3')"
                        color="red"
                      >
                        mdi-account-remove
                      </v-icon>
                    </div>
                  </template>

                  <template v-slot:[`item.observacion`]="{ item }">
                    <div v-if="item.proveedor3 != null">
                      <div>
                        <v-icon
                          @click="observacionProveedores(item)"
                          color="primary"
                          >mdi-file-search-outline</v-icon
                        >
                      </div>
                    </div>
                  </template>

                  <template v-slot:no-data>
                    <div class="no-data-container">
                      <v-icon class="no-data-icon" color="grey"
                        >mdi-alert-circle</v-icon
                      >
                      <div class="no-data-text">No se encontró su búsqueda</div>
                    </div>
                  </template>

                  <template v-slot:[`item.archivo`]="{ item }">
                    <v-icon
                      v-if="item.ruta_img"
                      color="green"
                      class="ml-5 file-icon"
                      @click="verArchivos(item)"
                      >mdi-eye</v-icon
                    >
                  </template>
                </v-data-table>
              </div>
            </v-tab-item>

            <v-tab-item :value="'tab-2'" class="tab-content">
              <div class="table-section">
                <v-data-table
                  :headers="headers1"
                  :items="procesosDenegados"
                  :search="search"
                  class="modern-table"
                  :items-per-page="10"
                  :footer-props="{
                    'items-per-page-options': [10, 20, 50],
                    'items-per-page-text': 'Filas por página:',
                  }"
                >
                  <template v-slot:[`item.pdfGeneral`]="{ item }">
                    <v-icon
                      class="mr-2 pdf-icon"
                      @click="modalPdf(item)"
                      color="red"
                      >mdi-file-pdf-box
                    </v-icon>
                  </template>

                  <template v-slot:no-data>
                    <div class="no-data-container">
                      <v-icon class="no-data-icon" color="grey"
                        >mdi-alert-circle</v-icon
                      >
                      <div class="no-data-text">No se encontró su búsqueda</div>
                    </div>
                  </template>
                </v-data-table>
              </div>
            </v-tab-item>
          </v-tabs>
        </div>
      </div>
    </div>
    <!-- Snackbar -->
    <v-snackbar
      v-model="snackbar"
      :bottom="y === 'bottom'"
      :left="x === 'left'"
      :multi-line="mode === 'multi-line'"
      :right="x === 'right'"
      :timeout="timeout"
      :top="y === 'top'"
      :vertical="mode === 'vertical'"
      class="modern-snackbar"
      color="primary"
    >
      {{ text }}
      <template v-slot:action="{ attrs }">
        <v-btn color="white" text v-bind="attrs" @click="snackbar = false">
          Cerrar
        </v-btn>
      </template>
    </v-snackbar>

    <!-- Modal para ver archivos adjuntos (idéntico a DirectorArea) -->
    <v-dialog
      v-model="dialogArchivos"
      max-width="900px"
      overlay-color="black"
      overlay-opacity="0.8"
    >
      <v-card>
        <v-card-title class="headline">Archivos Adjuntos</v-card-title>
        <v-card-text>
          <v-row>
            <v-col
              v-for="(archivo, idx) in archivosModal"
              :key="idx"
              cols="12"
              sm="6"
              md="4"
              lg="3"
              class="d-flex flex-column align-center"
            >
              <div
                v-if="esImagen(archivo)"
                class="archivo-preview"
                @click="abrirArchivo(archivo)"
                :style="'cursor: pointer; width: 180px; height: 180px; display: flex; align-items: center; justify-content: center; background: #f5f5f5; border-radius: 8px; overflow: hidden;'"
              >
                <v-img :src="archivo" contain height="100%" width="100%" />
              </div>
              <div
                v-else
                class="archivo-preview d-flex flex-column align-center justify-center"
                @click="abrirArchivo(archivo)"
                :style="'cursor: pointer; width: 180px; height: 180px; display: flex; align-items: center; justify-content: center; background: #f5f5f5; border-radius: 8px; overflow: hidden;'"
              >
                <v-icon color="primary" size="60">mdi-file-document</v-icon>
                <span
                  class="mt-2 text-center"
                  :style="'font-size: 13px; word-break: break-all;'"
                  >{{ nombreArchivo(archivo) }}</span
                >
              </div>
              <div
                v-if="esImagen(archivo)"
                class="mt-2 text-center"
                :style="'font-size: 13px; word-break: break-all; max-width: 180px;'"
              >
                {{ nombreArchivo(archivo) }}
              </div>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="dialogArchivos = false"
            >Cerrar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from "axios";
import env from "../env";
export default {
  data() {
    return {
      selectedAreaId: null,
      selectedAreaId2: null,
      selectedAreaId3: null,
      dialogArchivos: false,
      archivosModal: [],
      procesos: [], // Lista de procesos
      isArchivo: false,
      isExcel: false,
      isPdf: false, // Estado para verificar si el archivo es PDF
      filesToUpload: [],
      selectedFile: null, // Eliminar la declaración duplicada
      selectedFile2: null, // Eliminar la declaración duplicada
      selectedFile3: null, // Eliminar la declaración duplicada
      previewImage: null,
      filesToUpload: null,
      show: false,
      snackbar: false,
      y: "top",
      x: null,
      mode: "",
      timeout: 6000,
      text: "",
      search: "",
      areas: [],
      arregloDescripciones: [],
      arregloDescripciones1: [],
      arregloDescripciones2: [],
      estadoDescripciones: false,
      estadoDescripciones1: false,
      estadoDescripciones2: false,
      procesos: [],
      infoProceso: [],
      procesosDenegados: [],
      procesosFinalizados: [],
      valoresProveedores: [],
      tab1: null,
      tab2: null,
      estadoProveedor1: false,
      estadoProveedor2: false,
      dialog: false,
      dialogpdf: false,
      dialog1: false,
      dialog2: false,
      dialogEdit: false,
      dialog1Edit: false,
      dialog2Edit: false,
      observacionDialog: false,
      nuevaObservacion: "",
      showUploadCard: false,
      idProceso: "", // Eliminar la declaración duplicada de `idProceso`
      currentId: 0,
      currentId2: 0,
      currentId3: 0,
      limpiar: null,
      isSaving: false,
      loadingMessage: "",

      // 🎯 VARIABLES PARA EL SISTEMA DE CREACIÓN DE PROVEEDORES
      showCreateMessage1: false, // Mensaje para proveedor1
      showCreateMessage2: false, // Mensaje para proveedor2
      showCreateMessage3: false, // Mensaje para proveedor3
      isConsulting: false, // Loading durante consulta
      isCreating: false, // Loading durante creación
      consultaTimeout: null, // Para el delay del autocompletado

      // 🎯 VALIDACIÓN DE NIT - Permitir carácter @
      nitRules: [
        (v) => {
          const valor = (v || "").toString();
          if (!valor) return true; // permitir vacío visualmente
          // Permitir @ en NIT - solo validar dígitos
          const digitos = (valor.match(/\d/g) || []).join("");
          return (
            (digitos.length >= 8 && digitos.length <= 15) ||
            "NIT debe tener entre 8 y 15 dígitos numéricos"
          );
        },
      ],
      nitErrorMessages: [],
      isNitValid: false,
      // ✅ Variables de cache para optimización
      cacheProcesos: null,
      cacheProcesosDenegados: null,
      cacheTimestamp: null,
      cacheTimeout: 30000, // 30 segundos
      headers: [
        {
          text: "Id",
          align: "left",
          value: "idProceso",
          align: "center",
          sortable: false,
          class: "column",
        },
        {
          text: "Empresa",
          value: "empresa",
          align: "center",
          sortable: false,
          class: "column",
        },
        {
          text: "Concepto",
          value: "infofrase",
          align: "center",
          sortable: false,
          class: "column",
        },
        {
          text: "Adjunto",
          value: "archivo",
          align: "center",
          sortable: false,
          class: "column",
        },
        {
          text: "Director Area",
          value: "nombre",
          align: "center",
          sortable: false,
          class: "column",
        },
        {
          text: "Fecha Creación",
          value: "fechaCreacion",
          align: "center",
          sortable: false,
          class: "column",
        },
        {
          text: "Proveedor 1",
          value: "proveedor1",
          align: "center",
          sortable: false,
          class: "column",
        },
        {
          text: "Proveedor 2",
          value: "proveedor2",
          align: "center",
          sortable: false,
          class: "column",
        },
        {
          text: "Proveedor 3",
          value: "proveedor3",
          align: "center",
          sortable: false,
          class: "column",
        },
        {
          text: "Argumento para la compra",
          value: "observacion",
          align: "center",
          sortable: false,
          class: "column",
        },
      ],
      headers1: [
        {
          text: "Id",
          align: "left",
          value: "idProceso",
          align: "center",
          sortable: false,
          class: "column",
        },
        {
          text: "Director Area",
          value: "nombre",
          align: "center",
          sortable: false,
          class: "column",
        },
        {
          text: "General",
          value: "pdfGeneral",
          align: "center",
          sortable: false,
          class: "column",
        },
        {
          text: "Argumento para la compra",
          value: "observacion",
          align: "center",
          sortable: false,
          class: "column",
        },
        {
          text: "Observacion Denegada",
          value: "observacionDenegada",
          align: "center",
          sortable: false,
          class: "column",
        },
      ],
      // proveedor 1
      defaultItem: {
        infoProceso: {
          idProceso: "",
          concepto: "",
          cantidad: "",
          expecificaciones: "",
          observaciones: "",
        },
        infoProveedores: {
          proveedor1: {
            valores: {},
            idRegistro: "",
            idProceso: "",
            nombreEmpresa: "",
          },
        },
      },
      editedIndex: -1,
      editedItem: {
        infoProceso: {
          idProceso: "",
          concepto: "",
          cantidad: "",
          expecificaciones: "",
          observaciones: "",
        },
        infoProveedores: {
          proveedor1: {
            nombreEmpresa: "",
            nit: "",
            contacto: "",
            telefono: "",
            fechaEntrega: "",
            direccionEntrega: "",
            ejecutaPresupuesto: "",
          },
          proveedor2: {
            nombreEmpresa: "",
            nit: "",
            contacto: "",
            telefono: "",
            fechaEntrega: "",
            direccionEntrega: "",
            ejecutaPresupuesto: "",
          },
          proveedor3: {
            nombreEmpresa: "",
            nit: "",
            contacto: "",
            telefono: "",
            fechaEntrega: "",
            direccionEntrega: "",
            ejecutaPresupuesto: "",
          },
        },
      },
      // proveedor 2
      defaultItem1: {
        infoProceso: {
          idProceso: "",
          concepto: "",
          cantidad: "",
          expecificaciones: "",
          observaciones: "",
        },
        infoProveedores: {
          proveedor2: {
            valores: {},
            idRegistro: "",
            idProceso: "",
            nombreEmpresa: "",
            nit: "",
            contacto: "",
            telefono: "",
            fechaEntrega: "",
            direccionEntrega: "",
            ejecutaPresupuesto: "",
          },
        },
      },
      editedIndex1: -1,
      editedItem1: {
        infoProceso: {
          idProceso: "",
          concepto: "",
          cantidad: "",
          expecificaciones: "",
          observaciones: "",
        },
        infoProveedores: {
          proveedor2: {
            valores: {},
            idRegistro: "",
            idProceso: "",
            nombreEmpresa: "",
            nit: "",
            contacto: "",
            telefono: "",
            fechaEntrega: "",
            direccionEntrega: "",
            ejecutaPresupuesto: "",
          },
        },
      },
      // proveedor 3
      defaultItem2: {
        infoProceso: {
          concepto: "",
          cantidad: "",
          expecificaciones: "",
          observaciones: "",
        },
        infoProveedores: {
          proveedor3: {
            valores: {},
            idRegistro: "",
            idProceso: "",
            nombreEmpresa: "",
            nit: "",
            contacto: "",
            telefono: "",
            fechaEntrega: "",
            direccionEntrega: "",
            ejecutaPresupuesto: "",
          },
        },
      },
      editedIndex2: -1,
      editedItem2: {
        infoProceso: {
          concepto: "",
          cantidad: "",
          expecificaciones: "",
          observaciones: "",
        },
        infoProveedores: {
          proveedor3: {
            valores: {},
            idRegistro: "",
            idProceso: "",
            nombreEmpresa: "",
            nit: "",
            contacto: "",
            telefono: "",
            fechaEntrega: "",
            direccionEntrega: "",
            ejecutaPresupuesto: "",
          },
        },
      },
      editedItemDenegados: {},
      rules: {
        required: (value) => !!value || "Required.",
        counter: (value) => value.length <= 20 || "Maximo 20 characteres",
      },
    };
  },
  computed: {
    formTitle() {
      return "Proveedor 1";
    },
    formTitle1() {
      return "Proveedor 2";
    },
    formTitle2() {
      return "Proveedor 3";
    },
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
    dialog1(val) {
      val || this.close1();
    },
    dialog2(val) {
      val || this.close2();
    },
    // Watcher para limpiar campos cuando cambia el NIT del proveedor 1
    "editedItem.infoProveedores.proveedor1.nit": function (newNit, oldNit) {
      if (newNit !== oldNit) {
        this.editedItem.infoProveedores.proveedor1.nombreEmpresa = "";
        this.editedItem.infoProveedores.proveedor1.contacto = "";
        this.editedItem.infoProveedores.proveedor1.telefono = "";
        this.editedItem.infoProveedores.proveedor1.fechaEntrega = "";
        this.editedItem.infoProveedores.proveedor1.direccionEntrega = "";
        this.editedItem.infoProveedores.proveedor1.ejecutaPresupuesto = "";
      }
    },
    // Watcher para limpiar campos cuando cambia el NIT del proveedor 2
    "editedItem1.infoProveedores.proveedor2.nit": function (newNit, oldNit) {
      if (newNit !== oldNit) {
        this.editedItem1.infoProveedores.proveedor2.nombreEmpresa = "";
        this.editedItem1.infoProveedores.proveedor2.contacto = "";
        this.editedItem1.infoProveedores.proveedor2.telefono = "";
        this.editedItem1.infoProveedores.proveedor2.fechaEntrega = "";
        this.editedItem1.infoProveedores.proveedor2.direccionEntrega = "";
        this.editedItem1.infoProveedores.proveedor2.ejecutaPresupuesto = "";
      }
    },
    // Watcher para limpiar campos cuando cambia el NIT del proveedor 3
    "editedItem2.infoProveedores.proveedor3.nit": function (newNit, oldNit) {
      if (newNit !== oldNit) {
        this.editedItem2.infoProveedores.proveedor3.nombreEmpresa = "";
        this.editedItem2.infoProveedores.proveedor3.contacto = "";
        this.editedItem2.infoProveedores.proveedor3.telefono = "";
        this.editedItem2.infoProveedores.proveedor3.fechaEntrega = "";
        this.editedItem2.infoProveedores.proveedor3.direccionEntrega = "";
        this.editedItem2.infoProveedores.proveedor3.ejecutaPresupuesto = "";
      }
    },
  },
  mounted() {
    this.obtenerProcesos();
    this.obtenerAreas();
  },
  methods: {
    setEjecutaPresupuestoNombre(proveedor) {
      let areaId = null;
      if (proveedor === "proveedor1") areaId = this.selectedAreaId;
      if (proveedor === "proveedor2") areaId = this.selectedAreaId2;
      if (proveedor === "proveedor3") areaId = this.selectedAreaId3;
      const area = this.areas.find((a) => a.idArea === areaId);
      if (area) {
        if (proveedor === "proveedor1")
          this.editedItem.infoProveedores.proveedor1.ejecutaPresupuesto =
            area.nombreArea;
        if (proveedor === "proveedor2")
          this.editedItem1.infoProveedores.proveedor2.ejecutaPresupuesto =
            area.nombreArea;
        if (proveedor === "proveedor3")
          this.editedItem2.infoProveedores.proveedor3.ejecutaPresupuesto =
            area.nombreArea;
      }
    },
    verArchivos(item) {
      // Si item.ruta_img es un array, lo usamos directamente; si es string, lo convertimos a array
      if (Array.isArray(item.ruta_img)) {
        this.archivosModal = item.ruta_img;
      } else if (item.ruta_img) {
        // Si es string separado por comas
        if (typeof item.ruta_img === "string" && item.ruta_img.includes(",")) {
          this.archivosModal = item.ruta_img.split(",").map((s) => s.trim());
        } else {
          this.archivosModal = [item.ruta_img];
        }
      } else {
        this.archivosModal = [];
      }
      this.dialogArchivos = true;
    },
    faltaValorUnitario(arr) {
      return (
        !Array.isArray(arr) ||
        arr.length === 0 ||
        arr.some(
          (d) => !d || d.valorUnitario === null || d.valorUnitario === "",
          //  ELIMINADO: Number(d.valorUnitario) <= 0
          // Ahora permite valores de 0 y negativos
        )
      );
    },

    // 🎯 Validación condicional para Proveedor 2
    validarFormularioProveedor2() {
      const proveedor = this.editedItem1.infoProveedores.proveedor2;
      const nit = (proveedor.nit || "").toString().trim();
      const nombreEmpresa = (proveedor.nombreEmpresa || "").trim();
      const contacto = (proveedor.contacto || "").trim();
      const telefono = (proveedor.telefono || "").trim();
      const direccionEntrega = (proveedor.direccionEntrega || "").trim();
      const ejecutaPresupuesto = (proveedor.ejecutaPresupuesto || "").trim();
      const tieneAreaSeleccionada = this.selectedAreaId2 !== null;
      const tieneValorUnitario = !this.faltaValorUnitario(
        this.arregloDescripciones1,
      );

      // Verificar si algún campo tiene valor
      const tieneAlgunCampoLleno =
        nit !== "" ||
        nombreEmpresa !== "" ||
        contacto !== "" ||
        telefono !== "" ||
        direccionEntrega !== "" ||
        ejecutaPresupuesto !== "" ||
        tieneAreaSeleccionada ||
        tieneValorUnitario;

      // Si no hay ningún campo lleno, permitir guardar (formulario vacío)
      if (!tieneAlgunCampoLleno) {
        return true;
      }

      // Si hay algún campo lleno, validar que TODOS los campos obligatorios estén completos
      // Validar NIT (debe tener entre 8 y 15 dígitos si está lleno)
      if (nit !== "") {
        const digitos = (nit.match(/\d/g) || []).join("");
        if (digitos.length < 8 || digitos.length > 15) {
          return false;
        }
      }

      // Todos los campos deben estar llenos (excepto archivo)
      return (
        nit !== "" &&
        nombreEmpresa !== "" &&
        contacto !== "" &&
        telefono !== "" &&
        direccionEntrega !== "" &&
        (ejecutaPresupuesto !== "" || tieneAreaSeleccionada) &&
        tieneValorUnitario
      );
    },

    // 🎯 Validación condicional para Proveedor 3
    validarFormularioProveedor3() {
      const proveedor = this.editedItem2.infoProveedores.proveedor3;
      const nit = (proveedor.nit || "").toString().trim();
      const nombreEmpresa = (proveedor.nombreEmpresa || "").trim();
      const contacto = (proveedor.contacto || "").trim();
      const telefono = (proveedor.telefono || "").trim();
      const direccionEntrega = (proveedor.direccionEntrega || "").trim();
      const ejecutaPresupuesto = (proveedor.ejecutaPresupuesto || "").trim();
      const tieneAreaSeleccionada = this.selectedAreaId3 !== null;
      const tieneValorUnitario = !this.faltaValorUnitario(
        this.arregloDescripciones2,
      );

      // Verificar si algún campo tiene valor
      const tieneAlgunCampoLleno =
        nit !== "" ||
        nombreEmpresa !== "" ||
        contacto !== "" ||
        telefono !== "" ||
        direccionEntrega !== "" ||
        ejecutaPresupuesto !== "" ||
        tieneAreaSeleccionada ||
        tieneValorUnitario;

      // Si no hay ningún campo lleno, permitir guardar (formulario vacío)
      if (!tieneAlgunCampoLleno) {
        return true;
      }

      // Si hay algún campo lleno, validar que TODOS los campos obligatorios estén completos
      // Validar NIT (debe tener entre 8 y 15 dígitos si está lleno)
      if (nit !== "") {
        const digitos = (nit.match(/\d/g) || []).join("");
        if (digitos.length < 8 || digitos.length > 15) {
          return false;
        }
      }

      // Todos los campos deben estar llenos (excepto archivo)
      return (
        nit !== "" &&
        nombreEmpresa !== "" &&
        contacto !== "" &&
        telefono !== "" &&
        direccionEntrega !== "" &&
        (ejecutaPresupuesto !== "" || tieneAreaSeleccionada) &&
        tieneValorUnitario
      );
    },

    async obtenerAreas() {
      try {
        const res = await axios.get(`${env.endpoint}user/areas`);
        this.areas = res.data;
      } catch (err) {
        // console.error("Error cargando las áreas:", err);
      }
    },
    esImagen(archivo) {
      // Extensiones de imagen comunes
      return /\.(jpg|jpeg|png|gif|bmp|webp)$/i.test(archivo);
    },
    nombreArchivo(archivo) {
      // Extrae el nombre del archivo de la ruta
      return archivo.split("/").pop();
    },
    async consultarProveedor(proveedorKey) {
      try {
        let proveedorData;

        switch (proveedorKey) {
          case "proveedor1":
            proveedorData = this.editedItem.infoProveedores.proveedor1;
            break;
          case "proveedor2":
            proveedorData = this.editedItem1.infoProveedores.proveedor2;
            break;
          case "proveedor3":
            proveedorData = this.editedItem2.infoProveedores.proveedor3;
            break;
          default:
            return;
        }

        // 🔧 MEJORAR VALIDACIÓN DEL NIT - Permitir carácter @
        const nitOriginal = proveedorData.nit?.toString() || "";
        // Extraer solo dígitos para validación de longitud, pero mantener @ si existe
        const nit = (nitOriginal.match(/\d/g) || []).join("");
        if (!nit || nit.length < 8 || nit.length > 15) {
          return;
        }

        const res = await axios.post(`${env.endpoint}user/consultarProveedor`, {
          nit: nitOriginal, // Enviar NIT original con @ si existe
          nombre_empresa: proveedorData.nombreEmpresa,
          contacto: proveedorData.contacto,
          telefono: proveedorData.telefono,
        });

        if (res.data.success) {
          // Proveedor existe - autocompletar datos
          const prov = res.data.proveedor;

          proveedorData.idProveedor = prov.idProveedor;

          if (!proveedorData.nombreEmpresa)
            proveedorData.nombreEmpresa = prov.nombre_empresa;
          if (!proveedorData.contacto) proveedorData.contacto = prov.contacto;
          if (!proveedorData.telefono) proveedorData.telefono = prov.telefono;
        } else {
          // Proveedor NO existe - mostrar mensaje de creación

          //  ACTIVAR MENSAJE DE CREACIÓN SEGÚN EL PROVEEDOR
          switch (proveedorKey) {
            case "proveedor1":
              this.showCreateMessage1 = true;
              break;
            case "proveedor2":
              this.showCreateMessage2 = true;
              break;
            case "proveedor3":
              this.showCreateMessage3 = true;
              break;
          }
        }
      } catch (err) {
        // console.error("Error en consultarProveedor:", err);
      }
    },

    // 🎯 MÉTODO: Consultar en tiempo real con delay
    async consultarProveedorEnTiempoReal(proveedorKey) {
      let proveedorData;

      switch (proveedorKey) {
        case "proveedor1":
          proveedorData = this.editedItem.infoProveedores.proveedor1;
          break;
        case "proveedor2":
          proveedorData = this.editedItem1.infoProveedores.proveedor2;
          break;
        case "proveedor3":
          proveedorData = this.editedItem2.infoProveedores.proveedor3;
          break;
        default:
          return;
      }

      // Permitir caracteres especiales en NIT (guiones, puntos, espacios, @, etc.) - solo extraer dígitos para validación de longitud
      const nitOriginal = proveedorData.nit?.toString() || "";
      const nit = (nitOriginal.match(/\d/g) || []).join("");

      // Limpiar timeout anterior
      clearTimeout(this.consultaTimeout);

      // Consultar si tiene entre 8 y 15 dígitos (ignorando caracteres especiales)
      if (nit && nit.length >= 8 && nit.length <= 15) {
        // Delay de 500ms para evitar consultas excesivas
        this.consultaTimeout = setTimeout(() => {
          this.consultarProveedor(proveedorKey);
        }, 500);
      } else {
        // Si no tiene entre 8-15 dígitos, limpiar campos y ocultar mensaje
        if (nit && (nit.length < 8 || nit.length > 15)) {
          this.limpiarCamposProveedor(proveedorKey);
          this.ocultarMensajeCreacion(proveedorKey);
        }
      }
    },

    // 🎯 MÉTODO: Limpiar campos del proveedor específico
    limpiarCamposProveedor(proveedorKey) {
      switch (proveedorKey) {
        case "proveedor1":
          this.editedItem.infoProveedores.proveedor1.nombreEmpresa = "";
          this.editedItem.infoProveedores.proveedor1.contacto = "";
          this.editedItem.infoProveedores.proveedor1.telefono = "";
          break;
        case "proveedor2":
          this.editedItem1.infoProveedores.proveedor2.nombreEmpresa = "";
          this.editedItem1.infoProveedores.proveedor2.contacto = "";
          this.editedItem1.infoProveedores.proveedor2.telefono = "";
          break;
        case "proveedor3":
          this.editedItem2.infoProveedores.proveedor3.nombreEmpresa = "";
          this.editedItem2.infoProveedores.proveedor3.contacto = "";
          this.editedItem2.infoProveedores.proveedor3.telefono = "";
          break;
      }
    },

    // 🎯 MÉTODO: Validar NIT en tiempo real
    validarNitInput(proveedorKey) {
      let valor = "";
      switch (proveedorKey) {
        case "proveedor1":
          valor = this.editedItem.infoProveedores.proveedor1.nit || "";
          break;
        case "proveedor2":
          valor = this.editedItem1.infoProveedores.proveedor2.nit || "";
          break;
        case "proveedor3":
          valor = this.editedItem2.infoProveedores.proveedor3.nit || "";
          break;
      }

      // Permitir caracteres especiales en NIT (guiones, puntos, espacios, @, etc.) - solo remover caracteres no válidos
      const nitLimpio = valor.replace(/[^\d\-\.\s@]/g, "");

      // Validar que tenga entre 8 y 15 dígitos (ignorando caracteres especiales)
      const digitos = nitLimpio.replace(/[^\d]/g, "");
      if (digitos.length >= 8 && digitos.length <= 15) {
        this.nitErrorMessages = [];
        this.isNitValid = true;
        this.consultarProveedorEnTiempoReal(proveedorKey);
      } else if (digitos.length > 0 && digitos.length < 8) {
        this.nitErrorMessages = [
          "NIT incompleto - faltan " + (8 - digitos.length) + " dígitos",
        ];
        this.isNitValid = false;
      } else if (digitos.length > 15) {
        this.nitErrorMessages = ["NIT demasiado largo - máximo 15 dígitos"];
        this.isNitValid = false;
      } else {
        this.nitErrorMessages = [];
        this.isNitValid = false;
      }
    },

    // 🎯 MÉTODO: Validar que todos los NITs sean válidos - Permitir caracteres especiales
    validarNitCompleto() {
      // Permitir caracteres especiales en NIT (guiones, puntos, espacios, @, etc.) - solo remover caracteres no válidos
      const nit1 = (
        this.editedItem.infoProveedores.proveedor1.nit || ""
      ).replace(/[^\d\-\.\s@]/g, "");
      const nit2 = (
        this.editedItem1.infoProveedores.proveedor2.nit || ""
      ).replace(/[^\d\-\.\s@]/g, "");
      const nit3 = (
        this.editedItem2.infoProveedores.proveedor3.nit || ""
      ).replace(/[^\d\-\.\s@]/g, "");

      // Validar que todos los NITs tengan entre 8 y 15 dígitos (ignorando caracteres especiales)
      const digitos1 = nit1.replace(/[^\d]/g, "");
      const digitos2 = nit2.replace(/[^\d]/g, "");
      const digitos3 = nit3.replace(/[^\d]/g, "");

      const nit1Valido =
        !nit1 || (digitos1.length >= 8 && digitos1.length <= 15);
      const nit2Valido =
        !nit2 || (digitos2.length >= 8 && digitos2.length <= 15);
      const nit3Valido =
        !nit3 || (digitos3.length >= 8 && digitos3.length <= 15);

      if (!nit1Valido) {
        this.mostrarMensaje(
          "El NIT del Proveedor 1 debe tener entre 8 y 15 dígitos",
          "error",
        );
        return false;
      }
      if (!nit2Valido) {
        this.mostrarMensaje(
          "El NIT del Proveedor 2 debe tener entre 8 y 15 dígitos",
          "error",
        );
        return false;
      }
      if (!nit3Valido) {
        this.mostrarMensaje(
          "El NIT del Proveedor 3 debe tener entre 8 y 15 dígitos",
          "error",
        );
        return false;
      }

      return true;
    },

    // 🎯 MÉTODO: Crear proveedor cuando el usuario confirma
    async crearProveedorConfirmado(proveedorKey) {
      let proveedorData;

      switch (proveedorKey) {
        case "proveedor1":
          proveedorData = this.editedItem.infoProveedores.proveedor1;
          break;
        case "proveedor2":
          proveedorData = this.editedItem1.infoProveedores.proveedor2;
          break;
        case "proveedor3":
          proveedorData = this.editedItem2.infoProveedores.proveedor3;
          break;
        default:
          return;
      }

      if (!proveedorData.nombreEmpresa?.trim()) {
        this.mostrarMensaje("El nombre de la empresa es requerido", "error");
        return;
      }

      this.isCreating = true;

      try {
        const response = await axios.post(
          `${env.endpoint}user/crearProveedor`,
          {
            nit: proveedorData.nit || "", // Mantener NIT original con @ si existe
            nombre_empresa: proveedorData.nombreEmpresa,
            contacto: proveedorData.contacto,
            telefono: proveedorData.telefono,
          },
        );

        if (response.data.success) {
          this.mostrarMensaje("Proveedor creado exitosamente", "success");
          this.ocultarMensajeCreacion(proveedorKey);
          // Recargar datos si es necesario
        } else {
          this.mostrarMensaje(
            response.data.message || "Error al crear proveedor",
            "error",
          );
        }
      } catch (error) {
        // console.error("Error:", error);
        this.mostrarMensaje("Error al crear proveedor", "error");
      } finally {
        this.isCreating = false;
      }
    },

    //  MÉTODO: Ocultar mensaje de creación
    ocultarMensajeCreacion(proveedorKey) {
      switch (proveedorKey) {
        case "proveedor1":
          this.showCreateMessage1 = false;
          break;
        case "proveedor2":
          this.showCreateMessage2 = false;
          break;
        case "proveedor3":
          this.showCreateMessage3 = false;
          break;
      }
    },

    // 🎯 MÉTODO: Mostrar mensaje
    mostrarMensaje(mensaje, tipo) {
      this.text = mensaje;
      this.snackbar = true;
      // Opcional: cambiar color del snackbar según el tipo
      if (tipo === "success") {
        this.snackbarColor = "#4caf50";
      } else if (tipo === "error") {
        this.snackbarColor = "#f44336";
      } else if (tipo === "warning") {
        this.snackbarColor = "#ff9800";
      }
    },

    // 🎯 MÉTODO: Calcular subtotal correctamente con decimales - CORREGIDO
    calcularSubtotalProveedor(valores) {
      if (!valores || !Array.isArray(valores)) return 0;

      let subtotal = 0;
      valores.forEach((valor) => {
        // ✅ SOLUCIÓN: valor.valorTotal ya es un número, solo sumarlo directamente
        subtotal += Number(valor.valorTotal) || 0;
      });

      // ✅ Asegurar que el subtotal sea un número (no string con coma)
      return Number(subtotal);
    },

    abrirArchivo(archivo) {
      window.open(archivo, "_blank");
    },
    viewImage(rutaImg) {
      window.open(rutaImg, "_blank");
    },
    // ✅ Método optimizado para obtener los procesos
    async obtenerProcesos() {
      const now = Date.now();

      // ✅ Verificar cache (30 segundos de validez)
      if (
        this.cacheProcesos &&
        this.cacheProcesosDenegados &&
        this.cacheTimestamp &&
        now - this.cacheTimestamp < this.cacheTimeout
      ) {
        this.procesos = this.cacheProcesos;
        this.procesosDenegados = this.cacheProcesosDenegados;
        return Promise.resolve();
      }

      try {
        // ✅ Hacer ambas llamadas en paralelo
        const [procesosRes, denegadosRes] = await Promise.all([
          axios.get(`${env.endpoint}user/procesosCompras`),
          axios.get(`${env.endpoint}user/procesosComprasDenegados`),
        ]);

        // ✅ Procesar ambos arrays en paralelo
        this.procesos = procesosRes.data.map((proceso) =>
          this.transformarProcesoCompras(proceso),
        );
        this.procesosDenegados = denegadosRes.data.map((proceso) =>
          this.transformarProcesoDenegado(proceso),
        );

        // ✅ Guardar en cache
        this.cacheProcesos = this.procesos;
        this.cacheProcesosDenegados = this.procesosDenegados;
        this.cacheTimestamp = now;
      } catch (error) {
        console.error("Error obteniendo procesos:", error);
      }
    },

    // ✅ Método helper para transformar procesos de compras
    transformarProcesoCompras(proceso) {
      const infoProceso = Array.isArray(proceso.infoProceso)
        ? proceso.infoProceso
        : [];

      // ✅ Optimizar normalización de nombre del director
      const directorAreaNombre = this.obtenerNombreDirector(proceso);

      return {
        ...proceso,
        proveedor1: proceso.proveedor1 || null,
        proveedor2: proceso.proveedor2 || null,
        proveedor3: proceso.proveedor3 || null,
        infofrase: infoProceso.map((e) => e.concepto).join(", "),
        empresa: [...new Set(infoProceso.map((e) => e.empresa))].join(", "),
        nombre: directorAreaNombre,
      };
    },

    // ✅ Método helper para transformar procesos denegados
    transformarProcesoDenegado(proceso) {
      return {
        ...proceso,
        nombre: this.obtenerNombreDirector(proceso),
      };
    },

    // ✅ Método helper para obtener nombre del director
    obtenerNombreDirector(proceso) {
      return (
        proceso.nombreDirector ||
        proceso.nombreDirectorArea ||
        proceso.directorArea ||
        (proceso.director &&
          (proceso.director.nombre || proceso.director.nombreUsuario)) ||
        (proceso.directorArea &&
          (proceso.directorArea.nombre ||
            proceso.directorArea.nombreUsuario)) ||
        proceso.director ||
        (proceso.usuario &&
          (proceso.usuario.nombre || proceso.usuario.nombreUsuario)) ||
        proceso.nombreUsuario ||
        proceso.directorNombre ||
        proceso.nombre ||
        ""
      );
    },

    // ✅ Método helper para refrescar datos (con cache invalidado)
    async refrescarProcesos() {
      // Invalidar cache para forzar recarga
      this.cacheProcesos = null;
      this.cacheProcesosDenegados = null;
      this.cacheTimestamp = null;

      await this.obtenerProcesos();
    },

    // metodo para traer la informacion del proceso y llenar model para llenar los datos
    dialogProveedor1(item) {
      this.editedIndex = this.procesos.indexOf(item);
      this.currentId = this.editedItem.idProceso = item.idProceso;
      this.editedItem.infoProceso = Object.assign({}, item.infoProceso);

      this.crearInputs();
      this.dialog = true;
    },
    // metodo para traer la informacion del proceso y llenar model para llenar los datos
    dialogProveedor2(item) {
      this.editedIndex1 = this.procesos.indexOf(item);
      this.currentId2 = this.editedItem1.idProceso = item.idProceso;
      this.editedItem1.infoProceso = Object.assign({}, item.infoProceso);

      this.crearInputs1();
      this.dialog1 = true;
    },
    // metodo para traer la informacion del proceso y llenar model para llenar los datos
    dialogProveedor3(item) {
      this.editedIndex2 = this.procesos.indexOf(item);
      this.currentId3 = this.editedItem2.idProceso = item.idProceso;
      this.editedItem2.infoProceso = Object.assign({}, item.infoProceso);

      this.crearInputs2();
      this.dialog2 = true;
    },

    // metodo para traer la informacion del proceso y editar model para llenar los datos
    dialogEditProveedor1(item) {
      this.editedIndex = this.procesosDenegados.indexOf(item);
      this.editedItem.idProceso = item.idProceso;
      this.editedItem.infoProceso = Object.assign({}, item.infoProceso);
      this.editedItem.infoProveedores.proveedor1 = Object.assign(
        {},
        item.proveedor1,
      );
      this.crearInputs();
      this.arregloDescripciones = item.proveedor1.valores;
      // Normalizar valores unitarios
      this.normalizarValoresUnitariosProcesos(this.arregloDescripciones);
      this.dialogEdit = true;
    },
    // metodo para traer la informacion del proceso y editar model para llenar los datos
    dialogEditProveedor2(item) {
      this.editedIndex1 = this.procesos.indexOf(item);
      this.editedItem1.idProceso = item.idProceso;
      this.editedItem1.infoProceso = Object.assign({}, item.infoProceso);
      this.editedItem1.infoProveedores.proveedor2 = Object.assign(
        {},
        item.proveedor2,
      );
      this.crearInputs1();
      this.arregloDescripciones1 = item.proveedor2.valores;
      // Normalizar valores unitarios
      this.normalizarValoresUnitariosProcesos(this.arregloDescripciones1);
      this.dialog1Edit = true;
    },
    // metodo para traer la informacion del proceso y editar model para llenar los datos
    dialogEditProveedor3(item) {
      this.editedIndex2 = this.procesos.indexOf(item);
      this.editedItem2.idProceso = item.idProceso;
      this.editedItem2.infoProceso = Object.assign({}, item.infoProceso);
      this.editedItem2.infoProveedores.proveedor3 = Object.assign(
        {},
        item.proveedor3,
      );
      this.crearInputs2();
      this.arregloDescripciones2 = item.proveedor3.valores;
      // Normalizar valores unitarios
      this.normalizarValoresUnitariosProcesos(this.arregloDescripciones2);
      this.dialog2Edit = true;
    },

    limpiarProveedor(item, proveedor) {
      swal({
        title: "¿Estás seguro de eliminar?",
        text: "Una vez eliminada, no podrás recuperar estos datos.",
        icon: "warning",
        buttons: ["Cancelar", "Eliminar"],
        dangerMode: true,
      }).then((willDelete) => {
        if (willDelete) {
          let formData = new FormData();
          formData.append("proveedor", proveedor);
          formData.append("idProceso", item.idProceso);
          axios
            .post(`${env.endpoint}user/limpiarProveedor`, formData)
            .then((res) => {
              this.limpiar = res.data;
              if (this.limpiar.estado == true) {
                this.refrescarProcesos();
              }
            });
        }
      });
    },
    /**
     * Metodo para cerrar la modal
     */
    close() {
      this.dialog = false;
      this.dialogEdit = false;
      this.dialogpdf = false;
      this.estadoDescripciones = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedItem.idProceso = Object.assign(
          {},
          this.defaultItem.idProceso,
        );
        this.editedItem.infoProceso = Object.assign(
          {},
          this.defaultItem.infoProceso,
        );
        this.editedIndex = -1;
      }, 300);
    },
    /**
     * Metodo para cerrar la modal
     */
    close1() {
      this.dialog1 = false;
      this.dialog1Edit = false;
      this.estadoDescripciones1 = false;
      setTimeout(() => {
        this.editedItem1 = Object.assign({}, this.defaultItem1);
        this.editedItem1.idProceso = Object.assign(
          {},
          this.defaultItem1.idProceso,
        );
        this.editedItem1.infoProceso = Object.assign(
          {},
          this.defaultItem1.infoProceso,
        );
        this.editedIndex1 = -1;
      }, 300);
    },
    /**
     * Metodo para cerrar la modal
     */
    close2() {
      this.dialog2 = false;
      this.dialog2Edit = false;
      this.estadoDescripciones2 = false;
      setTimeout(() => {
        this.editedItem2 = Object.assign({}, this.defaultItem2);
        this.editedItem2.idProceso = Object.assign(
          {},
          this.defaultItem2.idProceso,
        );
        this.editedItem2.infoProceso = Object.assign(
          {},
          this.defaultItem2.infoProceso,
        );
        this.editedIndex2 = -1;
      }, 300);
    },
    // metodo para crear dinamicamente los campos de valor unitario, valor total e iva para el proveedor 1
    crearInputs() {
      this.estadoDescripciones = true;
      const size = Array.isArray(this.editedItem.infoProceso)
        ? this.editedItem.infoProceso.length
        : Object.keys(this.editedItem.infoProceso).length;

      this.arregloDescripciones = []; // limpia antes
      for (let index = 0; index < size; index++) {
        const valores = {
          idDescripcion: this.editedItem.infoProceso[index].id,
          valorUnitario: null,
          iva: 0,
          subtotal: 0,
          valorTotal: 0,
        };
        this.$set(this.arregloDescripciones, index, valores);
      }
    },

    crearInputs1() {
      this.estadoDescripciones1 = true;
      const size = Array.isArray(this.editedItem1.infoProceso)
        ? this.editedItem1.infoProceso.length
        : Object.keys(this.editedItem1.infoProceso).length;

      this.arregloDescripciones1 = [];
      for (let index = 0; index < size; index++) {
        const valores = {
          idDescripcion: this.editedItem1.infoProceso[index].id,
          valorUnitario: null,
          iva: 0,
          subtotal: 0,
          valorTotal: 0,
        };
        this.$set(this.arregloDescripciones1, index, valores);
      }
    },

    crearInputs2() {
      this.estadoDescripciones2 = true;
      const size = Array.isArray(this.editedItem2.infoProceso)
        ? this.editedItem2.infoProceso.length
        : Object.keys(this.editedItem2.infoProceso).length;

      this.arregloDescripciones2 = [];
      for (let index = 0; index < size; index++) {
        const valores = {
          idDescripcion: this.editedItem2.infoProceso[index].id,
          valorUnitario: null,
          iva: 0,
          subtotal: 0,
          valorTotal: 0,
        };
        this.$set(this.arregloDescripciones2, index, valores);
      }
    },

    // SUBIR IMAGEN PROVEEDOR1
    async submitUpload() {
      // this.handleFileChange();

      let proveedoresId = this.procesos.map((e) => {
        return e.idProceso;
      });

      try {
        // Verifica si los datos necesarios están presentes
        if (!this.procesos || !this.currentId) {
          // console.error("Error: idProceso no encontrado en currentItem.");
          alert("Error al cargar las imágenes. idProceso no encontrado.");
          return;
        }
        const formData = new FormData();

        // if (this.selectedFile) {
        //     formData.append('ruta_img1', this.selectedFile);
        // } else {
        //     alert("Por favor, selecciona un archivo.");
        //     return;
        // }

        formData.append("ruta_img1", this.selectedFile);
        formData.append("idProceso", this.currentId);

        // Enviar la solicitud al servidor
        const response = await axios.post(
          `${env.uploadBase}archivos/upload.php`,
          formData,
        );

        if (response.data) {
          swal("¡Imagen cargada correctamente!", {
            icon: "success",
          });
          // ✅ Refrescar la tabla para reflejar la nueva imagen
          this.refrescarProcesos();
        } else {
          swal("Error", "Hubo un problema al cargar la imagen.", "error");
        }
      } catch (error) {
        // console.error("Error al cargar la imagen:", error);
        if (error.response) {
          alert(
            `Error del servidor: ${error.response.status} - ${error.response.statusText}`,
          );
        } else if (error.request) {
          alert(
            "No se pudo contactar con el servidor. Intenta de nuevo más tarde.",
          );
        } else {
          // Otros errores
          alert("Hubo un error al procesar la solicitud. Intenta de nuevo.");
        }
      } finally {
        this.showUploadCard = false;
        this.selectedFile = null;
      }
    },

    //SUBIR IMAGEN PROVEEDOR2
    async submitUpload2() {
      // this.handleFileChange();

      let proveedoresId = this.procesos.map((e) => {
        return e.idProceso;
      });

      try {
        // Verifica si los datos necesarios están presentes
        if (!this.procesos || !this.currentId2) {
          // console.error("Error: idProceso no encontrado en currentItem.");
          alert("Error al cargar las imágenes. idProceso no encontrado.");
          return;
        }

        const formData = new FormData();
        formData.append("ruta_img2", this.selectedFile2);
        formData.append("idProceso", this.currentId2);

        // Enviar la solicitud al servidor
        const response = await axios.post(
          `${env.uploadBase}archivos/upload2.php`,
          formData,
        );

        if (response.data) {
          swal("¡Imagen cargada correctamente!", {
            icon: "success",
          });
          // ✅ Refrescar la tabla para reflejar la nueva imagen
          this.refrescarProcesos();
        } else {
          swal("Error", "Hubo un problema al cargar la imagen.", "error");
        }
      } catch (error) {
        // console.error("Error al cargar la imagen:", error);
        alert("Hubo un error al cargar la imagen");
      } finally {
        this.showUploadCard = false;
        this.selectedFile2 = null;
      }
    },

    async submitUpload3() {
      // this.handleFileChange();

      let proveedoresId = this.procesos.map((e) => {
        return e.idProceso;
      });

      try {
        // Verifica si los datos necesarios están presentes
        if (!this.procesos || !this.currentId3) {
          // console.error("Error: idProceso no encontrado en currentItem.");
          alert("Error al cargar las imágenes. idProceso no encontrado.");
          return;
        }

        // Crear el objeto FormData y añadir los datos
        const formData = new FormData();
        formData.append("ruta_img3", this.selectedFile3);
        formData.append("idProceso", this.currentId3);

        // Enviar la solicitud al servidor
        const response = await axios.post(
          `${env.uploadBase}archivos/upload3.php`,
          formData,
        );

        // Verifica si la respuesta es exitosa
        if (response.data) {
          swal("¡Imagen cargada correctamente!", {
            icon: "success",
          });
          // ✅ Refrescar la tabla para reflejar la nueva imagen
          this.refrescarProcesos();
        } else {
          swal("Error", "Hubo un problema al cargar la imagen.", "error");
        }
      } catch (error) {
        // console.error("Error al cargar la imagen:", error);
        alert("Hubo un error al cargar la imagen");
      } finally {
        this.showUploadCard = false;
        this.selectedFile3 = null;
      }
    },

    /**
     * Metodo para guardar cada proveedor
     */
    async save() {
      const idUsuario =
        this.procesos.length > 0 ? this.procesos[0].idUsuario : null;
      if (!idUsuario) return;

      // ✅ Crear objeto NUEVO con SOLO datos de Proveedor 1
      const proveedor1Data = this.editedItem.infoProveedores.proveedor1;
      const valores = this.arregloDescripciones;

      const prov1ParaBackend = {
        nit: proveedor1Data.nit || "",
        nombreEmpresa: proveedor1Data.nombreEmpresa || "",
        contacto: proveedor1Data.contacto || "",
        telefono: proveedor1Data.telefono || "",
        fechaEntrega: proveedor1Data.fechaEntrega || "",
        direccionEntrega: proveedor1Data.direccionEntrega || "",
        ejecutaPresupuesto: proveedor1Data.ejecutaPresupuesto || "",
        ciudad: proveedor1Data.ciudad || "",
        valores: valores,
        subTotal: this.calcularSubtotalProveedor(valores),
        // ❌ NO incluir proveedor2, proveedor3, observacion
      };

      console.log("✅ Objeto a enviar:", prov1ParaBackend);
      const infoProveedor = JSON.stringify(prov1ParaBackend);
      console.log("✅ JSON a enviar:", infoProveedor);

      try {
        const res = await axios.get(`${env.endpoint}user/infoProveedor1`, {
          params: {
            info: infoProveedor,
            idProceso: this.editedItem.idProceso,
            idUser: idUsuario,
          },
        });

        if (res.data === true) {
          this.refrescarProcesos();
        } else {
          throw new Error("Proveedor 1 no se pudo registrar");
        }
      } catch (error) {
        console.error("Error proveedor 1:", error);
        throw new Error("Error al registrar proveedor 1");
      }

      this.arregloDescripciones = [];
    },
    async save1() {
      const idUsuario =
        this.procesos.length > 0 ? this.procesos[0].idUsuario : null;
      if (!idUsuario) {
        this.mostrarMensaje(
          "Error: No se pudo identificar el usuario.",
          "error",
        );
        return;
      }

      // ✅ Crear objeto nuevo para Proveedor 2
      const proveedor2Data = this.editedItem1.infoProveedores.proveedor2;
      const valores = this.arregloDescripciones1;

      const prov2ParaBackend = {
        nit: proveedor2Data.nit || "",
        nombreEmpresa: proveedor2Data.nombreEmpresa || "",
        contacto: proveedor2Data.contacto || "",
        telefono: proveedor2Data.telefono || "",
        fechaEntrega: proveedor2Data.fechaEntrega || "",
        direccionEntrega: proveedor2Data.direccionEntrega || "",
        ejecutaPresupuesto: proveedor2Data.ejecutaPresupuesto || "",
        ciudad: proveedor2Data.ciudad || "",
        valores: valores,
        subTotal: this.calcularSubtotalProveedor(valores),
        // Indicador de proveedor 2
      };

      const infoProveedor = JSON.stringify(prov2ParaBackend);

      try {
        const res = await axios.get(`${env.endpoint}user/infoProveedor2`, {
          params: {
            info: infoProveedor,
            idProceso: this.editedItem1.idProceso,
          },
        });

        if (res.data === true) {
          this.obtenerProcesos();
        } else {
          throw new Error("Proveedor 2 no se pudo registrar");
        }
      } catch (error) {
        console.error("Error proveedor 2:", error);
        throw new Error("Error al registrar proveedor 2");
      }

      this.arregloDescripciones1 = [];
    },

    async save2() {
      const idUsuario =
        this.procesos.length > 0 ? this.procesos[0].idUsuario : null;
      if (!idUsuario) {
        this.mostrarMensaje(
          "Error: No se pudo identificar el usuario.",
          "error",
        );
        return;
      }

      // ✅ Crear objeto nuevo para Proveedor 3
      const proveedor3Data = this.editedItem2.infoProveedores.proveedor3;
      const valores = this.arregloDescripciones2;

      const prov3ParaBackend = {
        nit: proveedor3Data.nit || "",
        nombreEmpresa: proveedor3Data.nombreEmpresa || "",
        contacto: proveedor3Data.contacto || "",
        telefono: proveedor3Data.telefono || "",
        fechaEntrega: proveedor3Data.fechaEntrega || "",
        direccionEntrega: proveedor3Data.direccionEntrega || "",
        ejecutaPresupuesto: proveedor3Data.ejecutaPresupuesto || "",
        ciudad: proveedor3Data.ciudad || "",
        valores: valores,
        subTotal: this.calcularSubtotalProveedor(valores),
        // Indicador de proveedor 3
      };

      const infoProveedor = JSON.stringify(prov3ParaBackend);

      try {
        const res = await axios.get(`${env.endpoint}user/infoProveedor3`, {
          params: {
            info: infoProveedor,
            idProceso: this.editedItem2.idProceso,
          },
        });

        if (res.data === true) {
          this.obtenerProcesos();
        } else {
          throw new Error("Proveedor 3 no se pudo registrar");
        }
      } catch (error) {
        console.error("Error proveedor 3:", error);
        throw new Error("Error al registrar proveedor 3");
      }

      this.arregloDescripciones2 = [];
    },

    async handleSave() {
      // Cerrar modal inmediatamente
      this.close();

      // Overlay global
      this.showGlobalOverlay("Guardando proveedor...");

      try {
        await this.save();
        // Actualizar mensaje del overlay
        this.showGlobalOverlay("Subiendo imagen...");
        await this.submitUpload();

        // Mensaje de éxito eliminado - ya no se muestra
      } catch (error) {
        // console.error("Error:", error);
        this.snackbar = true;
        this.text = error.message || "Error al procesar proveedor 1 ❌";
      } finally {
        // Cerrar overlay global
        this.hideGlobalOverlay();
      }
    },
    async handleSave2() {
      // Cerrar modal inmediatamente
      this.close1();

      // Overlay global
      this.showGlobalOverlay("Guardando proveedor...");
      try {
        await this.save1();
        // Actualizar mensaje del overlay
        this.showGlobalOverlay("Subiendo imagen...");
        await this.submitUpload2();

        // Mensaje de éxito eliminado - ya no se muestra
      } catch (error) {
        // console.error("Error:", error);
        this.snackbar = true;
        this.text = error.message || "Error al procesar proveedor 2 ❌";
      } finally {
        // Cerrar overlay global
        this.hideGlobalOverlay();
      }
    },
    async handleSave3() {
      // Cerrar modal inmediatamente
      this.close2();

      // Overlay global
      this.showGlobalOverlay("Guardando proveedor...");
      try {
        await this.save2();
        // Actualizar mensaje del overlay
        this.showGlobalOverlay("Subiendo imagen...");
        await this.submitUpload3();

        // Mensaje de éxito eliminado - ya no se muestra
      } catch (error) {
        // console.error("Error:", error);
        this.snackbar = true;
        this.text = error.message || "Error al procesar proveedor 3 ❌";
      } finally {
        // Cerrar overlay global
        this.hideGlobalOverlay();
      }
    },

    observacionProveedores(item) {
      this.editedIndex2 = this.procesos.indexOf(item);
      this.editedItem2.idProceso = item.idProceso;
      this.editedItem2.infoProceso = Object.assign({}, item.infoProceso);

      this.crearInputs2();
      this.observacionDialog = true;
    },
    // Cierra la card de observaciones
    cerrarObservacion() {
      this.observacionDialog = false;
    },
    async enviarObservacion() {
      // Obtén el `idUsuario` necesario. Aquí asumo que es el primer usuario de la lista.
      const idUsuario =
        this.procesos.length > 0 ? this.procesos[0].idUsuario : null;

      if (!idUsuario) return;

      const infoObservacion = encodeURIComponent(this.nuevaObservacion || "");

      // Cerrar el diálogo y mostrar overlay de carga
      this.cerrarObservacion();
      this.showGlobalOverlay("Enviando observación...");

      try {
        const res = await axios.get(
          `${env.endpoint}user/nuevaObservacion?info=${infoObservacion}&idUser=${idUsuario}&idProceso=${this.editedItem2.idProceso}`,
        );

        if (res.data === true) {
          // ✅ No mostrar snackbar de éxito, solo cerrar overlay
          this.refrescarProcesos();
        } else {
          this.snackbar = true;
          this.text = "No se pudo enviar la observación";
        }
      } catch (error) {
        this.snackbar = true;
        this.text = "Ocurrió un error al enviar la observación";
      } finally {
        this.hideGlobalOverlay();
        this.nuevaObservacion = "";
      }
    },
    edit() {
      this.editedItem.infoProveedores.proveedor1.valores =
        this.arregloDescripciones;
      this.editedItem.infoProveedores.proveedor1.estadoProveedor1 = 1;
      let infoProveedor = JSON.stringify(
        this.editedItem.infoProveedores.proveedor1,
      );
      axios
        .get(
          `${env.endpoint}user/modificarProveedor1?info=${infoProveedor}&idProceso=${this.editedItem.idProceso}`,
        )
        .then((res) => {
          if (res.data === true) {
            (this.snackbar = true),
              (this.text = "Proveedor 1 Actualizado satisfactoriamente");
          } else if (res === false) {
            (this.snackbar = true),
              (this.text = "Proveedor 1 no se pudo Actualizadar");
          }
        });
      this.arregloDescripciones = [];
      // ✅ this.estadoProveedor1 = true
      this.refrescarProcesos();
      this.close();
    },
    edit1() {
      this.editedItem1.infoProveedores.proveedor2.valores =
        this.arregloDescripciones1;
      this.editedItem1.infoProveedores.proveedor2.estadoProveedor2 = 1;
      let infoProveedor = JSON.stringify(
        this.editedItem1.infoProveedores.proveedor2,
      );

      axios
        .get(
          `${env.endpoint}user/modificarProveedor2?info=${infoProveedor}&idProceso=${this.editedItem1.idProceso}`,
        )
        .then((res) => {
          if (res.data === true) {
            (this.snackbar = true),
              (this.text = "Proveedor 2 Actualizado satisfactoriamente");
          } else if (res === false) {
            (this.snackbar = true),
              (this.text = "Proveedor 2 no se pudo Actualizadar");
          }
        });
      this.arregloDescripciones1 = [];
      // this.estadoProveedor1 = false
      // this.estadoProveedor2 = true
      this.obtenerProcesos();
      this.close1();
    },
    edit2() {
      this.editedItem2.infoProveedores.proveedor3.valores =
        this.arregloDescripciones2;
      this.editedItem2.infoProveedores.proveedor3.estadoProveedor3 = 1;
      let infoProveedor = JSON.stringify(
        this.editedItem2.infoProveedores.proveedor3,
      );

      axios
        .get(
          `${env.endpoint}user/modificarProveedor3?info=${infoProveedor}&idProceso=${this.editedItem2.idProceso}`,
        )
        .then((res) => {
          if (res.data === true) {
            (this.snackbar = true),
              (this.text = "Proveedor 3 Actualizado satisfactoriamente");
          } else if (res === false) {
            (this.snackbar = true),
              (this.text = "Proveedor 3 no se pudo Actualizadar");
          }
        });
      this.arregloDescripciones2 = [];
      // this.estadoProveedor2 = false
      this.obtenerProcesos();
      this.close2();
    },

    modalPdf(item) {
      this.editedIndex = this.procesosDenegados.indexOf(item);
      this.editedItemDenegados = Object.assign({}, item);
      this.menosValor(this.editedItemDenegados);
      this.dialogpdf = true;
    },
    menosValor(item) {
      let valoresProveedor1 = item.proveedor1.valores;
      let valoresProveedor2 = item.proveedor2.valores;
      let valoresProveedor3 = item.proveedor3.valores;
      for (let index = 0; index < item.proveedor3.valores.length; index++) {
        let valoresFor = [];
        let proveedor1 = Number(valoresProveedor1[index].valorTotal);
        let proveedor2 = Number(valoresProveedor2[index].valorTotal);
        let proveedor3 = Number(valoresProveedor3[index].valorTotal);

        if (proveedor1 < proveedor2 && proveedor1 < proveedor3) {
          valoresFor.push(proveedor1);
        } else if (proveedor2 < proveedor1 && proveedor2 < proveedor3) {
          valoresFor.push(proveedor2);
        } else {
          valoresFor.push(proveedor3);
        }
        this.valoresProveedores.push(valoresFor);
      }
    },

    // 🎯 MÉTODO: Formatear valor unitario (CON decimales usando coma) - CORREGIDO
    formatearValorUnitario(item, event, cantidad) {
      // Manejar diferentes tipos de eventos
      let valor;
      if (typeof event === "string") {
        valor = event;
      } else if (event && event.target && event.target.value !== undefined) {
        valor = event.target.value;
      } else if (event && event.value !== undefined) {
        valor = event.value;
      } else {
        valor = item.valorUnitario || "";
      }

      if (!valor || valor.trim() === "") {
        return;
      }

      // 1) Limpiar caracteres no válidos (solo dígitos, puntos y coma)
      let valorNormalizado = valor.replace(/[^\d.,]/g, "");

      // 2) Separar parte entera y decimal
      const partes = valorNormalizado.split(",");
      let parteEntera = partes[0] || "0";
      let parteDecimal = partes[1] || "";

      // 3) Limitar decimales a máximo 2 dígitos
      if (parteDecimal.length > 2) {
        parteDecimal = parteDecimal.substring(0, 2);
      }

      // ✅ SOLUCIÓN CORREGIDA: Formatear parte entera correctamente
      // Primero eliminar todos los puntos existentes para empezar limpio
      parteEntera = parteEntera.replace(/\./g, "");

      // Luego formatear correctamente cada 3 dígitos desde la derecha
      if (parteEntera.length > 3) {
        // Convertir a número y usar toLocaleString para formateo correcto
        const numero = parseInt(parteEntera, 10);
        if (!isNaN(numero)) {
          parteEntera = numero.toLocaleString("es-ES").replace(/,/g, ".");
        }
      }

      // 4) Construir el valor final
      if (parteDecimal) {
        item.valorUnitario = parteEntera + "," + parteDecimal;
      } else {
        item.valorUnitario = parteEntera;
      }

      // Actualizar valor total si es necesario
      if (cantidad > 0) this.cambioValorTotal(item, cantidad);
    },

    // 🎯 MÉTODO: Obtener valor numérico limpio (maneja comas como decimales y puntos como miles)
    obtenerValorNumerico(valorFormateado) {
      if (!valorFormateado) return 0;

      // Si es string, convertir a número
      if (typeof valorFormateado === "string") {
        // Reemplazar puntos (separadores de miles) por nada
        let valorLimpio = valorFormateado.replace(/\./g, "");

        // Reemplazar coma (separador decimal) por punto para parseFloat
        valorLimpio = valorLimpio.replace(",", ".");

        return parseFloat(valorLimpio) || 0;
      }

      // Si ya es número, devolverlo
      return parseFloat(valorFormateado) || 0;
    },

    // 🎯 MÉTODO: Normalizar valores unitarios al cargar procesos (CON decimales)
    normalizarValoresUnitariosProcesos(arregloValores) {
      if (!arregloValores || !Array.isArray(arregloValores)) return;

      arregloValores.forEach((valor) => {
        if (valor.valorUnitario) {
          // Si es string, convertirlo manteniendo el formato con coma
          if (typeof valor.valorUnitario === "string") {
            // Convertir a número y luego formatear de nuevo
            const numeroLimpio = this.obtenerValorNumerico(valor.valorUnitario);

            // Formatear con coma decimal
            const parteEntera = Math.floor(numeroLimpio);
            const parteDecimal = Math.round((numeroLimpio - parteEntera) * 100);

            if (parteDecimal > 0) {
              // Formatear parte entera con puntos como separadores de miles
              const parteEnteraFormateada = parteEntera
                .toLocaleString("es-ES")
                .replace(/,/g, ".");
              valor.valorUnitario =
                parteEnteraFormateada +
                "," +
                parteDecimal.toString().padStart(2, "0");
            } else {
              // Solo parte entera
              valor.valorUnitario = parteEntera
                .toLocaleString("es-ES")
                .replace(/,/g, ".");
            }
          }
        }
      });
    },

    // 🎯 MÉTODO: Formatear valor unitario para mostrar (CON decimales)
    formatValorUnitario(value) {
      if (value === null || value === undefined || value === "") return "$ 0";

      // Convertir a número usando nuestro método
      const numero = this.obtenerValorNumerico(value);

      if (isNaN(numero)) return "$ 0";

      // Formatear con el formato colombiano (puntos para miles, coma para decimales)
      return new Intl.NumberFormat("es-CO", {
        style: "currency",
        currency: "COP",
        minimumFractionDigits: 0,
        maximumFractionDigits: 2, // Permitir hasta 2 decimales
      }).format(numero);
    },

    cambioValorTotal(item, cantidad) {
      let valorUnitario = this.obtenerValorNumerico(item.valorUnitario);
      let cantidades = Number(cantidad);
      item.valorTotal = valorUnitario * cantidades;
    },
    cambioValorTotal1(item, cantidad) {
      let valorUnitario = this.obtenerValorNumerico(item.valorUnitario);
      let cantidades = Number(cantidad);
      item.valorTotal = valorUnitario * cantidades;
    },
    cambioValorTotal2(item, cantidad) {
      let valorUnitario = this.obtenerValorNumerico(item.valorUnitario);
      let cantidades = Number(cantidad);
      item.valorTotal = valorUnitario * cantidades;
    },

    // Overlay global montado en body
    showGlobalOverlay(mensaje) {
      this.hideGlobalOverlay();
      const overlay = document.createElement("div");
      overlay.id = "global-loading-overlay";
      overlay.style.position = "fixed";
      overlay.style.top = "0";
      overlay.style.left = "0";
      overlay.style.width = "100%";
      overlay.style.height = "100%";
      overlay.style.background = "rgba(0,0,0,0.6)";
      overlay.style.zIndex = "9999";
      overlay.style.display = "flex";
      overlay.style.alignItems = "center";
      overlay.style.justifyContent = "center";
      overlay.style.backdropFilter = "blur(2px)";

      const card = document.createElement("div");
      card.style.background =
        "linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%)";
      card.style.borderRadius = "8px";
      card.style.padding = "32px 40px";
      card.style.minWidth = "320px";
      card.style.maxWidth = "90%";
      card.style.boxShadow =
        "0 20px 60px rgba(0,0,0,0.3), 0 0 0 1px rgba(255,255,255,0.1)";
      card.style.display = "flex";
      card.style.flexDirection = "column";
      card.style.alignItems = "center";
      card.style.textAlign = "center";
      card.style.border = "1px solid rgba(255,255,255,0.2)";
      card.style.position = "relative";
      card.style.overflow = "hidden";

      // Efecto de brillo animado
      const shine = document.createElement("div");
      shine.style.position = "absolute";
      shine.style.top = "0";
      shine.style.left = "-100%";
      shine.style.width = "100%";
      shine.style.height = "100%";
      shine.style.background =
        "linear-gradient(90deg, transparent, rgba(255,255,255,0.4), transparent)";
      shine.style.animation = "shine 2s ease-in-out infinite";
      card.appendChild(shine);

      // Contenedor del spinner
      const spinnerContainer = document.createElement("div");
      spinnerContainer.style.position = "relative";
      spinnerContainer.style.marginBottom = "20px";

      // Spinner principal
      const spinner = document.createElement("div");
      spinner.style.border = "4px solid rgba(25,118,210,0.1)";
      spinner.style.borderTop = "4px solid #1976d2";
      spinner.style.borderRadius = "50%";
      spinner.style.width = "60px";
      spinner.style.height = "60px";
      spinner.style.animation = "spin 1s linear infinite";
      spinner.style.position = "relative";
      spinner.style.zIndex = "2";

      // Spinner secundario (más pequeño)
      const spinner2 = document.createElement("div");
      spinner2.style.border = "3px solid rgba(76,175,80,0.1)";
      spinner2.style.borderTop = "3px solid #4caf50";
      spinner2.style.borderRadius = "50%";
      spinner2.style.width = "40px";
      spinner2.style.height = "40px";
      spinner2.style.animation = "spin 1.5s linear infinite reverse";
      spinner2.style.position = "absolute";
      spinner2.style.top = "10px";
      spinner2.style.left = "10px";
      spinner2.style.zIndex = "1";

      spinnerContainer.appendChild(spinner);
      spinnerContainer.appendChild(spinner2);

      // Texto principal
      const text = document.createElement("div");
      text.style.fontSize = "16px";
      text.style.fontWeight = "600";
      text.style.color = "#424242";
      text.style.marginBottom = "8px";
      text.style.letterSpacing = "0.2px";
      text.style.fontFamily =
        "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif";
      text.textContent = mensaje || "Procesando...";

      // Texto secundario
      const subText = document.createElement("div");
      subText.style.fontSize = "13px";
      subText.style.fontWeight = "400";
      subText.style.color = "#757575";
      subText.style.opacity = "0.9";
      subText.style.fontFamily =
        "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif";
      subText.textContent = "Por favor espere un momento";

      card.appendChild(spinnerContainer);
      card.appendChild(text);
      card.appendChild(subText);
      overlay.appendChild(card);
      document.body.appendChild(overlay);

      // Agregar estilos de animación si no existen
      if (!document.getElementById("loading-animations")) {
        const style = document.createElement("style");
        style.id = "loading-animations";
        style.textContent = `
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
          @keyframes shine {
            0% { left: -100%; }
            100% { left: 100%; }
          }
        `;
        document.head.appendChild(style);
      }
    },
    hideGlobalOverlay() {
      const overlay = document.getElementById("global-loading-overlay");
      if (overlay && overlay.parentNode) {
        overlay.parentNode.removeChild(overlay);
      }
    },
    // Helper visual para mostrar check cuando el NIT "limpio" es válido - Permitir caracteres especiales
    esNitValidoVisual(valor) {
      const nit = (valor || "").toString().replace(/[^\d\-\.\s@]/g, "");
      const digitos = nit.replace(/[^\d]/g, "");
      return digitos.length >= 8 && digitos.length <= 15;
    },
  },
};
</script>
<style scoped>
.drop-area {
  border: 2px dashed #bbb;
  padding: 20px;
  text-align: center;
  background-color: #f9f9f9;
  cursor: pointer;
}

.preview-image {
  max-width: 50px;
  max-height: 50px;
  margin-bottom: 10px;
}

.upload-button {
  border-radius: 4px;
  font-weight: 500;
  margin-top: 10px;
  padding: 10px 20px;
  background-color: rgb(247, 229, 6);
  color: black;
  cursor: pointer;
  font-size: 16px;
  transition: opacity 0.2s cubic-bezier(0.4, 0, 0.6, 1);
}

.loader-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.pdf-icon {
  max-width: 50px;
  max-height: auto;
  position: center;
}

.xls-icon {
  max-width: 50px;
  max-height: auto;
  position: center;
}

.preview-image {
  max-width: 100%;
  max-height: 200px;
  margin-bottom: 10px;
}

.loader {
  border: 4px solid rgba(255, 255, 255, 0.3);
  border-radius: 50%;
  border-top: 4px solid #ffffff;
  width: 40px;
  height: 40px;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

/*  ESTILOS PARA EL SISTEMA DE CREACIÓN DE PROVEEDORES */
.mensaje-creacion {
  animation: slideDown 0.3s ease-out;
  border-radius: 6px !important;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08) !important;
  border: 1px solid #e0e0e0 !important;
  background-color: #fafafa !important;
}

.mensaje-creacion .v-alert__content {
  padding: 16px !important;
}

/*  ICONO DE INFORMACIÓN (fondo blanco → gris oscuro) */
.mensaje-creacion .v-alert__content .v-icon {
  color: #616161 !important;
  font-size: 20px !important;
}

/*  ICONO DEL BOTÓN CREAR (fondo azul → blanco) */
.mensaje-creacion .v-btn--primary .icono-crear-blanco,
.mensaje-creacion .v-btn--primary .v-icon.icono-crear-blanco,
.v-btn--primary .icono-crear-blanco,
.icono-crear-blanco {
  color: white !important;
}

/*  FORZAR COLOR BLANCO CON MÁXIMA ESPECIFICIDAD */
.mensaje-creacion .v-btn.v-btn--primary .v-icon.icono-crear-blanco {
  color: white !important;
}

.mensaje-creacion .text-subtitle2 {
  color: #424242 !important;
  font-weight: 500 !important;
  font-size: 14px !important;
}

.mensaje-creacion .text-caption {
  color: #757575 !important;
  font-size: 12px !important;
  line-height: 1.4 !important;
}

@keyframes slideDown {
  from {
    opacity: 0;
    transform: translateY(-8px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.mensaje-creacion .v-card-actions {
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  padding: 8px 0 0 0 !important;
  margin-top: 8px;
}

.mensaje-creacion .v-card-actions .v-btn {
  border-radius: 4px;
  font-weight: 500;
  text-transform: none;
  letter-spacing: 0.5px;
  font-size: 12px;
}

.mensaje-creacion .v-btn--primary {
  background-color: #1976d2 !important;
  color: white !important;
}

/* 🎯 CLASE ESPECÍFICA PARA EL ICONO + DEL BOTÓN CREAR PROVEEDOR */
.icono-crear-blanco {
  color: white !important;
}

.mensaje-creacion .v-btn--outlined {
  border-color: #bdbdbd !important;
  color: #616161 !important;
}

/* Estilos mejorados para las pestañas - más profundidad y dinamismo */
.modern-tabs {
  background: #3b82f6 !important;
  border-radius: 0 !important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1) !important;
  position: relative !important;
  overflow: hidden !important;
}

.modern-tabs::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(
    45deg,
    rgba(255, 255, 255, 0.15) 0%,
    transparent 50%,
    rgba(255, 255, 255, 0.05) 100%
  );
  pointer-events: none;
  z-index: 1;
}

.modern-tabs >>> .v-tabs-bar {
  background: transparent !important;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.1) !important;
  position: relative;
  z-index: 2;
  border-radius: 0 !important;
}

.custom-tab {
  position: relative !important;
  overflow: hidden !important;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1) !important;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3) !important;
  border-radius: 0 !important;
  margin: 0 !important;
}

.custom-tab::before {
  content: "";
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    90deg,
    transparent,
    rgba(255, 255, 255, 0.2),
    transparent
  );
  transition: left 0.5s ease;
  z-index: 1;
}

.custom-tab:hover::before {
  left: 100%;
}

.custom-tab:hover {
  background: linear-gradient(
    135deg,
    rgba(255, 255, 255, 0.15) 0%,
    rgba(255, 255, 255, 0.05) 100%
  ) !important;
  transform: translateY(-2px) !important;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15) !important;
}

.custom-tab.v-tab--active {
  background: linear-gradient(
    135deg,
    rgba(255, 255, 255, 0.2) 0%,
    rgba(255, 255, 255, 0.1) 100%
  ) !important;
  box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.1), 0 4px 16px rgba(0, 0, 0, 0.15) !important;
  transform: translateY(-1px) !important;
}

.tab-text {
  font-weight: 700 !important;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3) !important;
  position: relative;
  z-index: 2;
}

.tab-icon {
  filter: drop-shadow(0 1px 2px rgba(0, 0, 0, 0.3)) !important;
  transition: all 0.3s ease !important;
  position: relative;
  z-index: 2;
}

.custom-tab:hover .tab-icon {
  transform: scale(1.1) !important;
}

.tabs-slider {
  height: 4px !important;
  box-shadow: 0 2px 8px rgba(59, 130, 246, 0.4) !important;
  border-radius: 2px !important;
}

/* ===== ESTILOS CORREGIDOS PARA PROCESOS.VUE ===== */

/* Contenedor principal */
.procesos-container {
  background: transparent !important;
  min-height: 100vh !important;
  padding: 0 !important;
}

/* Contenedor unificado */
.unified-container {
  background: white !important;
  border-radius: 0 !important;
  box-shadow: none !important;
  margin-left: 30px !important;
  margin-right: 0 !important;
  overflow: hidden !important;
  display: flex !important;
  flex-direction: column !important;
  min-height: 100vh !important;
}

/* Header section */
.header-section {
  margin-bottom: 0 !important;
}

.header-section {
  display: flex !important;
  justify-content: space-between !important;
  align-items: center !important;
  background: linear-gradient(135deg, #3b82f6 0%, #1e40af 100%) !important;
  border-radius: 0 !important;
  padding: 2rem 3rem !important;
  box-shadow: none !important;
  margin: 0 !important;
}

.title-section {
  display: flex !important;
  align-items: center !important;
  gap: 1.5rem !important;
}

.title-icon {
  font-size: 1.8rem !important;
}

.title-text {
  color: white !important;
}

.main-title {
  font-size: 1.8rem !important;
  font-weight: 700 !important;
  margin: 0 !important;
  letter-spacing: 0.5px !important;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3) !important;
}

.subtitle {
  font-size: 0.9rem !important;
  margin: 0.25rem 0 0 0 !important;
  opacity: 0.9 !important;
  font-weight: 400 !important;
}

/* Search section */
.search-section {
  margin-bottom: 0 !important;
  padding: 2rem 2rem 1.5rem 2rem !important;
  border-bottom: none !important;
  background: white !important;
  display: flex !important;
  justify-content: center !important;
}

.search-card {
  background: transparent !important;
  border-radius: 0 !important;
  box-shadow: none !important;
  border: none !important;
  max-width: 500px !important;
  width: 100% !important;
  padding: 0 !important;
}

.search-field >>> .v-input__control {
  background: white !important;
}

.search-field >>> .v-input__slot {
  background: white !important;
  border: 1px solid #dadce0 !important;
  border-radius: 24px !important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1) !important;
  transition: all 0.3s ease !important;
  min-height: 44px !important;
  padding: 0 16px !important;
}

.search-field >>> .v-input__slot:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15) !important;
  border-color: #dadce0 !important;
}

.search-field >>> .v-input__slot:focus-within {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15) !important;
  border-color: #3b82f6 !important;
}

.search-field >>> .v-input__control .v-input__append-inner {
  margin-right: 8px !important;
}

.search-field >>> .v-input__control .v-input__append-inner .v-icon {
  color: #5f6368 !important;
  font-size: 20px !important;
}

.search-field >>> .v-text-field__slot input {
  color: #202124 !important;
  font-size: 16px !important;
  font-weight: 400 !important;
  padding: 0 8px !important;
}

.search-field >>> .v-text-field__slot input::placeholder {
  color: #9aa0a6 !important;
  font-size: 16px !important;
}

/* Tabs section */
.tabs-section {
  margin-bottom: 0 !important;
  background: white !important;
}

.tabs-card {
  background: transparent !important;
  border-radius: 0 !important;
  box-shadow: none !important;
  border: none !important;
  overflow: hidden !important;
}

/* Table section */
.table-section {
  margin-bottom: 0 !important;
  padding: 0 !important;
  background: white !important;
  width: 100%;
  overflow-x: auto;
  overflow-y: visible;
}

/* ===== DISEÑO MINIMALISTA ELEGANTE ===== */
.modern-table {
  background: white !important;
  border-radius: 12px !important;
  overflow: visible !important;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1) !important;
  border: 1px solid #e5e7eb !important;
  min-width: 800px; /* Ancho mínimo para forzar scroll si es necesario */
}

.modern-table >>> .v-data-table__wrapper {
  border-radius: 12px !important;
  overflow-x: scroll !important; /* Scroll horizontal siempre visible */
  overflow-y: visible !important;
  background: white !important;
  max-width: 100%;
}

/* Estilos para el scrollbar horizontal siempre visible */
.modern-table >>> .v-data-table__wrapper::-webkit-scrollbar {
  height: 12px !important;
  display: block !important;
  -webkit-appearance: none;
}

.modern-table >>> .v-data-table__wrapper::-webkit-scrollbar-track {
  background: #e5e7eb !important;
  border-radius: 6px !important;
  margin: 0 10px;
}

.modern-table >>> .v-data-table__wrapper::-webkit-scrollbar-thumb {
  background: #64748b !important;
  border-radius: 6px !important;
  border: 2px solid #e5e7eb;
}

.modern-table >>> .v-data-table__wrapper::-webkit-scrollbar-thumb:hover {
  background: #475569 !important;
}

/* Para Firefox */
.modern-table >>> .v-data-table__wrapper {
  scrollbar-width: thin;
  scrollbar-color: #64748b #e5e7eb;
}

.modern-table >>> .v-data-table-header {
  background: white !important;
  border-bottom: 1px solid #e5e7eb !important;
  position: relative !important;
}

.modern-table >>> .v-data-table-header th {
  color: #374151 !important;
  font-weight: 600 !important;
  font-size: 0.8rem !important;
  text-transform: uppercase !important;
  letter-spacing: 0.8px !important;
  padding: 1rem 0.75rem !important;
  background: transparent !important;
  border-bottom: 2px solid #f3f4f6 !important;
}

.modern-table >>> .v-data-table__wrapper table tbody tr {
  transition: all 0.2s ease !important;
  border-bottom: 1px solid #f9fafb !important;
}

.modern-table >>> .v-data-table__wrapper table tbody tr:nth-child(even) {
  background: #fafbfc !important;
}

.modern-table >>> .v-data-table__wrapper table tbody tr:hover {
  background: #f8fafc !important;
  transform: translateY(-1px) !important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05) !important;
}

.modern-table >>> .v-data-table__wrapper table tbody tr td {
  color: #1f2937 !important;
  font-weight: 400 !important;
  border-bottom: 1px solid #f3f4f6 !important;
  padding: 1rem 0.75rem !important;
  font-size: 0.85rem !important;
  line-height: 1.5 !important;
  vertical-align: middle !important;
}

.modern-table >>> .file-icon {
  color: #059669 !important;
  background: transparent !important;
  border-radius: 0 !important;
  padding: 0.25rem !important;
  transition: all 0.2s ease !important;
  border: none !important;
}

.modern-table >>> .file-icon:hover {
  color: #047857 !important;
  background: transparent !important;
  border: none !important;
  transform: scale(1.1) !important;
}

.modern-table >>> .v-data-footer {
  background: white !important;
  border-top: 1px solid #e5e7eb !important;
  padding: 1rem !important;
  border-radius: 0 0 12px 12px !important;
}

.modern-table >>> .v-data-footer__select {
  color: #6b7280 !important;
  font-weight: 500 !important;
  font-size: 0.85rem !important;
}

.modern-table >>> .v-data-footer__pagination {
  color: #6b7280 !important;
  font-weight: 500 !important;
  font-size: 0.85rem !important;
}

.modern-table >>> .v-data-footer .v-btn {
  background: #f3f4f6 !important;
  color: #374151 !important;
  border: 1px solid #e5e7eb !important;
  border-radius: 6px !important;
  transition: all 0.2s ease !important;
  font-size: 0.85rem !important;
  padding: 0.5rem 0.75rem !important;
  font-weight: 500 !important;
}

.modern-table >>> .v-data-footer .v-btn:hover {
  background: #e5e7eb !important;
  border-color: #d1d5db !important;
  transform: translateY(-1px) !important;
}

/* Estilos para iconos de proveedores - Minimalista */
.modern-table >>> .v-icon[color="red"] {
  background: transparent !important;
  border-radius: 6px !important;
  padding: 6px !important;
  border: 1px solid #fecaca !important;
  color: #dc2626 !important;
  transition: all 0.3s ease !important;
}

.modern-table >>> .v-icon[color="red"]:hover {
  background: #fef2f2 !important;
  border-color: #fca5a5 !important;
  transform: scale(1.05) !important;
}

.modern-table >>> .v-icon[color="green"] {
  background: transparent !important;
  border-radius: 6px !important;
  padding: 6px !important;
  border: 1px solid #bbf7d0 !important;
  color: #16a34a !important;
  transition: all 0.3s ease !important;
}

.modern-table >>> .v-icon[color="green"]:hover {
  background: #f0fdf4 !important;
  border-color: #86efac !important;
  transform: scale(1.05) !important;
}
</style>
/* Estilos idénticos a DirectorArea para el modal de archivos adjuntos */
.archivo-preview-modal-director { cursor: pointer; width: 160px; height: 160px;
display: flex; align-items: center; justify-content: center; background:
#f5f5f5; border-radius: 8px; overflow: hidden; margin-bottom: 8px; box-shadow: 0
2px 8px rgba(0,0,0,0.06); } .archivo-nombre-modal-director { font-size: 13px;
word-break: break-all; max-width: 160px; text-align: center; margin-bottom:
12px; } /* Forzar scrim oscuro para el overlay de carga global */ /* (El overlay
global ahora se monta en body; esta regla ya no es necesaria)
.overlay-carga-global .v-overlay__scrim { background: rgba(0, 0, 0, 0.75)
!important; } */ /* ===== ESTILOS MODERNOS PARA PROCESOS.VUE ===== */ /*
Contenedor principal */ .procesos-container { padding: 2rem; background:
linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%); min-height: 100vh; } /*
Header Section */ .header-section { margin-bottom: 2rem; } .title-section {
display: flex; align-items: center; gap: 1.5rem; position: relative; z-index: 1;
} .icon-container { background: rgba(255, 255, 255, 0.2); border-radius: 12px;
padding: 1rem; backdrop-filter: blur(10px); border: 1px solid rgba(255, 255,
255, 0.3); } .title-icon { font-size: 2.5rem !important; } .title-text { flex:
1; } .main-title { color: white; font-size: 2.5rem; font-weight: 700; margin: 0;
text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3); letter-spacing: 1px; } .subtitle {
color: rgba(255, 255, 255, 0.9); font-size: 1.1rem; margin: 0.5rem 0 0 0;
font-weight: 400; text-shadow: 0 1px 2px rgba(0, 0, 0, 0.2); } /* Search Section
*/ .search-section { margin-bottom: 2rem; display: flex; justify-content:
center; } .search-card { background: white; border-radius: 12px; box-shadow: 0
4px 16px rgba(0, 0, 0, 0.1); border: 1px solid #e2e8f0; max-width: 500px; width:
100%; padding: 0.5rem; } .search-field { background: transparent !important; }
.search-field >>> .v-input__control { background: transparent !important; }
.search-field >>> .v-input__slot { background: transparent !important; border:
none !important; box-shadow: none !important; min-height: 48px !important; }
.search-field >>> .v-input__slot:hover { background: rgba(59, 130, 246, 0.05)
!important; border-radius: 8px !important; } .search-field >>>
.v-input__slot:focus-within { background: rgba(59, 130, 246, 0.1) !important;
border-radius: 8px !important; box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.2)
!important; } .search-field >>> .v-label { color: #64748b !important;
font-weight: 500 !important; } .search-field >>> .v-icon { color: #64748b
!important; } /* Tabs Section */ .tabs-section { margin-bottom: 1rem !important;
padding: 1rem !important; background: white !important; } .tabs-card {
background: white !important; border-radius: 8px !important; box-shadow: 0 4px
12px rgba(0, 0, 0, 0.1) !important; border: 1px solid #e2e8f0 !important;
overflow: hidden !important; } .modern-tabs { background: #6b7280 !important;
border-radius: 8px 8px 0 0 !important; border: none !important; box-shadow: none
!important; } .modern-tabs >>> .v-tabs-bar { background: #6b7280 !important; }
.modern-tabs >>> .v-tab { color: white !important; } .modern-tabs >>>
.v-tab--active { color: white !important; background: rgba(255, 255, 255, 0.1)
!important; } .tabs-slider { background: linear-gradient(135deg, #3b82f6 0%,
#1e40af 100%) !important; height: 3px !important; border-radius: 2px !important;
} .custom-tab { padding: 1.5rem 2rem !important; font-weight: 600 !important;
letter-spacing: 0.5px !important; transition: all 0.3s ease !important; color:
white !important; } .custom-tab:hover { background: rgba(255, 255, 255, 0.1)
!important; } .custom-tab.v-tab--active { background: rgba(255, 255, 255, 0.2)
!important; border-bottom: 3px solid #3b82f6 !important; } .tab-text {
font-size: 1rem !important; margin-right: 0.5rem !important; color: white
!important; } .tab-icon { font-size: 1.2rem !important; color: white !important;
} /* Tab Content */ .tab-content { padding: 0 !important; } /* Table Section */
.table-section { padding: 1.5rem; } .modern-table { background: transparent
!important; } .modern-table >>> .v-data-table__wrapper { border-radius: 12px
!important; overflow: hidden !important; box-shadow: 0 4px 16px rgba(0, 0, 0,
0.08) !important; border: 1px solid #e2e8f0 !important; } .modern-table >>>
.v-data-table-header { background: linear-gradient(135deg, #374151 0%, #4b5563
100%) !important; } .modern-table >>> .v-data-table-header th { color: white
!important; font-weight: 600 !important; font-size: 0.9rem !important;
letter-spacing: 0.5px !important; padding: 1rem 0.75rem !important; }
.modern-table >>> .v-data-table__wrapper table { border-collapse: separate
!important; border-spacing: 0 !important; } .modern-table >>> tbody tr {
transition: all 0.2s ease !important; } .modern-table >>> tbody tr:hover {
background: rgba(59, 130, 246, 0.05) !important; transform: translateY(-1px)
!important; box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1) !important; } .modern-table
>>> tbody td { padding: 1rem 0.75rem !important; border-bottom: 1px solid
#f1f5f9 !important; font-size: 0.9rem !important; color: #374151 !important; }
.modern-table >>> .v-data-footer { background: #f8fafc !important; border-top:
1px solid #e2e8f0 !important; padding: 1rem !important; } .modern-table >>>
.v-data-footer__select { color: #64748b !important; font-weight: 500 !important;
} .modern-table >>> .v-data-footer__pagination { color: #64748b !important;
font-weight: 500 !important; } /* No Data Container */ .no-data-container {
display: flex; flex-direction: column; align-items: center; justify-content:
center; padding: 3rem 2rem; text-align: center; } .no-data-icon { font-size:
3rem !important; margin-bottom: 1rem !important; opacity: 0.6; } .no-data-text {
color: #64748b; font-size: 1.1rem; font-weight: 500; } /* Icons */ .file-icon {
cursor: pointer; transition: all 0.2s ease; padding: 0.25rem; border-radius: 0;
} .file-icon:hover { background: transparent; transform: scale(1.1); } .pdf-icon
{ cursor: pointer; transition: all 0.2s ease; padding: 0.5rem; border-radius:
6px; } .pdf-icon:hover { background: rgba(239, 68, 68, 0.1); transform:
scale(1.1); } /* Snackbar */ .modern-snackbar { border-radius: 12px !important;
box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2) !important; } /* Responsive */ /*
Unified Container Styles */ .unified-container { background: white;
border-radius: 16px; box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1); margin: 0 1rem;
overflow: hidden; display: flex; flex-direction: column; } .header-section {
margin-bottom: 0; } .header-content { border-radius: 0; box-shadow: none; }
.search-section { margin-bottom: 0; background: white; } .search-card {
background: transparent; border-radius: 0; box-shadow: none; border: none; }
.tabs-section { margin-bottom: 0; background: white; } .tabs-card { background:
transparent !important; border-radius: 0 !important; box-shadow: none
!important; border: none !important; } .table-section { background: white; }
@media (max-width: 768px) { .procesos-container { padding: 1rem; }
.unified-container { margin: 0 0.5rem; } .header-content { padding: 1.5rem; }
.title-section { flex-direction: column; text-align: center; gap: 1rem; }
.main-title { font-size: 1.5rem; } .custom-tab { padding: 1rem !important; }
.tab-text { font-size: 0.9rem !important; } .table-section { padding: 1rem; } }
@media (min-width: 1024px) and (max-width: 1480px) { .procesos-container {
padding: 2rem 1rem !important; } .unified-container { width: calc(100% - 2rem)
!important; max-width: none !important; margin: 0 auto !important; } }
